"use strict";

const DashboardDocumentType = {
    0: "HTML",
    1: "Javascript",
    2: "CSS",
    3: "ConvertedJs",
    4: "TestScript",
    5: "Markdown",
    6: "CompiledJavascript",
    7: "CompiledCss",
    HTML: 0,
    Javascript: 1,
    CSS: 2,
    ConvertedJs: 3,
    TestScript: 4,
    Markdown: 5,
    CompiledJavascript: 6,
    CompiledCss: 7
};

(function () {
    const Deferred = function () {
        const deferred = {};
        const promise = new Promise(((resolve, reject) => {
            deferred.resolve = resolve;
            deferred.reject = reject;
        }));

        deferred.then = function (onFulfilled, onRejected) {
            promise.then(onFulfilled, onRejected);
        };

        return deferred;
    };

    let args;

    const runTestFunction = (resolve, reject) => {
        ECP.Dialog.ShowLoading("Testing......", args.loadingCover ? args.loadingCover : "");

        const iFrames = document.querySelectorAll(".test-code-iframe");

        for (let index = 0; index < iFrames.length; index++) {
            document.body.removeChild(iFrames[index]);
        }

        const iframe = document.createElement("frame");

        iframe.classList.add("test-code-iframe");
        iframe.style.display = "none";
        iframe.style.height = "100%";
        iframe.style.width = "100%";

        iframe.onload = function () {
            iframe.contentWindow.onbeforeunload = function () {
                if (iframe.contentWindow.__coverage__ && iframe.contentWindow.ProcessTestScriptResult) {
                    iframe.contentWindow.ProcessTestScriptResult(iframe.contentWindow.__coverage__, iframe.contentWindow.document, true);
                } else {
                    clearInterval(timer);

                    const errorDialog = ECP.Dialog.ShowDialog("Test Scripts Failed", "<div style=margin:auto;padding-top:10px><center>The test script run failed because the test page has been unload (often through a 'location.href = ___' call).<br><br>Please fix your code and/or test cases<br>before saving as <i>released</i>.</center></div>", {
                        confirmButtonTitle: "OK"
                    });
                    errorDialog.querySelector(".ecp-dialog-content").style.fontSize = "15px";
                }

                iframe.contentWindow.MochaTested = true;
            };

            const timer = setInterval(() => {
                if (!iframe || !iframe.contentWindow || !iframe.contentWindow.document) {
                    clearInterval(timer);
                    return;
                }

                const iframeDocument = iframe.contentWindow.document;
                const mochaDom = iframeDocument.getElementById("mocha");

                if (mochaDom && iframe.contentWindow.MochaTested) {
                    ECP.Dialog.HideLoading();

                    mochaDom.style.width = "100%";

                    const titleLink = mochaDom.querySelector(".suite h1 a");

                    if (titleLink && args.dashboardItemID) {
                        titleLink.textContent = `Dashboard Item ${args.dashboardItemID}`;
                    }

                    const mochaLinks = mochaDom.querySelectorAll("a");

                    for (let i = 0; i < mochaLinks.length; i++) {
                        mochaLinks[i].setAttribute("href", "#");
                    }

                    const replayElements = mochaDom.getElementsByClassName("replay");

                    for (let i = 0; i < replayElements.length; i++) {
                        replayElements[i].setAttribute("href", "#");
                    }

                    clearInterval(timer);

                    let success = true;

                    if (parseInt(mochaDom.querySelector(".failures em").textContent, 10) > 0) {
                        success = false;
                    }

                    if (mochaDom.querySelector(".code-warning")) {
                        success = false;
                    }

                    const codeCoverage = mochaDom.querySelector(".code-coverage");

                    if (codeCoverage) {
                        const codeCoverageNum = codeCoverage.getAttribute("statement-coverage");

                        if (EC_Fmt.isNumber(codeCoverageNum) && parseFloat(codeCoverageNum).toFixed(2) * 100 < 80) {
                            success = false;

                            codeCoverage.style.color = "red";
                        }
                    } else {
                        success = false;
                    }

                    if (success) {
                        resolve();
                    } else {
                        reject();
                    }

                    const dialog = ECP.Dialog.ShowDialog("Test Result", mochaDom, {
                        width: 750,
                        height: 450,
                        confirmButtonTitle: success && args.confirmButtonTitle ? args.confirmButtonTitle : "OK",
                        confirmButtonAction: success ? args.confirmButtonAction : undefined
                    });

                    if (args.loadingCover && args.loadingCover.style) {
                        dialog.style.zIndex = parseInt(args.loadingCover.style.zIndex, 10) + 10;
                    }

                    if (args.tabCodeEditor && iframe.contentWindow.__coverage__[1]) {
                        const coverage = iframe.contentWindow.__coverage__[1];
                        const statementKeys = Object.keys(coverage.s);
                        const newDecorations = [];

                        for (let i = 0; i < statementKeys.length; i++) {
                            const statementResult = coverage.s[statementKeys[i]];
                            const statementMap = coverage.statementMap[i];
                            const className = statementResult > 0 ? "TestedLineDecoration" : "ErrorLineDecoration";

                            newDecorations.push({
                                range: new args.tabCodeEditor.CodeEditors.jsEditor.editor.monaco.Range(statementMap.start.line, 1, statementMap.end.line, 1),
                                options: {
                                    isWholeLine: false,
                                    linesDecorationsClassName: className,
                                    overviewRuler: statementResult === 0 ? { color: "rgba(255, 0, 0, 1)", position: 2 } : null
                                }
                            });
                        }

                        window.decorations = args.tabCodeEditor.CodeEditors.jsEditor.editor.monacoEditor.deltaDecorations(window.decorations || [], newDecorations);
                    }
                }
            }, 100);
        };

        iframe.onerror = function () {
            reject();
        };

        // Task 1090882: System error: BC_GlobalDocument: Can not create a new Global Document, FileName in BC_GlobalDocument is empty
        iframe.src = `Home?RunCodeItemTest=True&EmbededDialog=True&CodeType=Code&HtmlDocumentID=${args.GlobalHtmlDocumentID}&CssDocumentID=${args.GlobalCssDocumentID}&JsDocumentID=${args.GlobalJsDocumentID}&ConvertedJsDocumentID=${EC_Fmt.Null2EmptyStr(args.GlobalConvertedJsDocumentID)}&TestDocuemntID=${args.GlobalTestDocumentID}&CompiledJsDocumentID=${args.GlobalCompiledJsDocumentID}&CompiledCssDocumentID=${args.GlobalCompiledCssDocumentID}`;

        document.body.appendChild(iframe);
    };

    const generateAITestScript = async (GlobalHtmlDocumentID, GlobalCssDocumentID, GlobalJsDocumentID, JavaScriptConnect) => {
        const myRequest = new ECP.EC_Request("GenerateAITestScript");
        myRequest.SetReturnType(ECP.EC_ReturnType.Json);
        myRequest.AddRequestVariable("CSS", GlobalCssDocumentID);
        myRequest.AddRequestVariable("HTML", GlobalHtmlDocumentID);
        myRequest.AddRequestVariable("Javascript", GlobalJsDocumentID);
        myRequest.AddRequestVariable("JavaScriptConnect", JavaScriptConnect, ECP.EC_Verb.Post);
        const result = await myRequest.Submit();
        return result.code;
    };

    class TabCodeEditor {
        constructor() {
            this.EditorContainer = null;
            this.CodeEditors = {};
            this.Options = {};
            this.isSplitMove = false;
            this.linterDef = null;
            this.Markdown = null;
            this.SDK = null;
            this.NeedClearCDN = false;
            this.SaveDashboardCode = false;
            this.addNewItem = false;
        }

        InitEditors(dashboardItem, addNewItem) {
            const me = this;

            if (addNewItem) {
                me.addNewItem = true;
            }

            ECP.Dialog.ShowLoading("Loading Editor......");

            return new Promise(async (resolve, reject) => {
                if (EC_Fmt.isMobile) {
                    ECP.Dialog.HideLoading();
                    ECP.Dialog.Alert("The Code Block Editor is not supported on mobile devices.");

                    reject();
                } else if (!me.EditorContainer) {
                    // Task 669407: If another person has a code block open and is working on it, warn subsequent users when they open the code block to avoid changes over-writing eachother
                    let CodeBlockAlreadyOpenBy = { OpenBy_AuthenticationID: null };
                    if (dashboardItem && EC_Fmt.isInteger(dashboardItem.id)) {
                        CodeBlockAlreadyOpenBy = await fetch(`api?APICommand=Dashboard_MarkCodeBlockOpen&DashboardItemID=${dashboardItem.id}`, { credentials: "same-origin" });
                        CodeBlockAlreadyOpenBy = JSON.parse(await CodeBlockAlreadyOpenBy.text());
                    }

                    if (CodeBlockAlreadyOpenBy.OpenBy_AuthenticationID !== null) {
                        ECP.Dialog.HideLoading();
                        ECP.Dialog.ShowDialog("Confirm", `<br>This Code Block is already open and being edited by:<br><b>${CodeBlockAlreadyOpenBy.OpenBy_FullName}</b><br><br>Editing will override their pending changes.`, {
                            width: 450,
                            cancelButtonTitle: "Cancel",
                            confirmButtonTitle: "Override",
                            cancelButtonAction() {
                                reject();
                            },
                            confirmButtonAction(dialog) {
                                ECP.Dialog.CloseDialog(dialog);
                                ECP.Dialog.ShowLoading("Loading Editor......");
                                me.LoadEditor(dashboardItem, resolve);
                            }
                        });
                    } else {
                        me.LoadEditor(dashboardItem, resolve);
                    }
                } else {
                    ECP.Dialog.HideLoading();
                    resolve();
                }
            });
        }

        LoadEditor(dashboardItem, resolve) {
            const me = this;
            const html = `<div class=ews-code-container>`
                + `<div class=ews-code-title-bar>`
                + `<div class=ews-code-title-text>Code Block</div>`
                + `<div class=ews-code-buttons>`
                + `<div class=ews-code-action-buttons>`
                + ` <ecp-btn id=ews-code-save-button type=primary icon=ews-icon-save>Save Changes</ecp-btn>`
                + ` <ecp-btn id=ews-code-runtest-button>Run Test</ecp-btn>`
                + ` <ecp-btn id=ews-code-commit-button>Commit w/ Message</ecp-btn>`
                + ` <ecp-btn id=ews-code-viewHistory-button>View History</ecp-btn>`
                + ` <ecp-btn id=ews-code-generateAITestScript-button>Generate AI Test Script</ecp-btn>`
                + ` <ecp-btn id=ews-code-cancel-button type=ghost>Cancel</ecp-btn>`
                + `</div>`
                + `<div class="ews-code-action-buttons ews-code-preview-buttons">`
                + ` <ecp-btn id=ews-code-refresh-button>Refresh Preview</ecp-btn>`
                + ` <ecp-btn id=ews-code-preview-button>Open Preview</ecp-btn>`
                + `</div>`
                + `</div>`
                + `</div>`
                + `<div class=ews-code-content>`
                + `<div class=ews-code-tabs>`
                + `<div class="ews-code-tab ews-code-tab-selected"data-language=html data-type=html style=min-width:82px>`
                + ` <label class="ews-code-type-icon ews-icon-html"></label>`
                + ` <span>HTML</span>`
                + `</div>`
                + `<div class=ews-code-tab data-language=less data-type=css style=min-width:71px>`
                + ` <label class="ews-code-type-icon ews-icon-css"></label>`
                + ` <span>CSS</span>`
                + `</div>`
                + `<div class=ews-code-tab data-language=javascript" data-type=js style=min-width:112px>`
                + ` <label class="ews-code-type-icon ews-icon-js"></label>`
                + ` <span>Javascript</span>`
                + `</div>`
                + `<div class=ews-code-tab data-language=javascript data-type=test style=min-width:111px>`
                + ` <label class="ews-code-type-icon ews-icon-testscript"></label>`
                + ` <span>Test Script</span>`
                + `</div>`
                + `<div class=ews-code-tab data-language=markdown data-type=markdown style=min-width:149px>`
                + ` <label class="ews-code-type-icon ews-icon-markdown"></label>`
                + ` <span>Documentation</span>`
                + `</div>`
                + `<div class=ews-code-tab data-type=sdk>`
                + ` <span>SDK</span>`
                + ` <label class=ews-icon-externallink id=ews-code-sdk-externallink style=color:var(--primary-80);padding-left:5px;line-height:51px;cursor:alias></label>`
                + `</div>`
                + `<div style=flex:1;display:flex;justify-content:flex-end>`
                + `<div class=ews-code-autofix title="Fix all auto-fixable problems"><span class=ews-icon-screwdriver></span></div>`
                + `</div>${EC_Fmt.Null2EmptyStr(Settings.EnableBeta) === "true" ? "<div style=margin-right:26px;font-size:14px><h3>Editing Beta</h3></div>" : ""}</div>`
                + `<div class=ews-code-tab-editor>`
                + `<div class=ews-code-editors>`
                + `<div class=ews-code-wrap data-type=html>`
                + ` <editor id=htmlEditor name=htmlEditor language=html data-type=html lib="UI/Editor"></editor>`
                + `</div>`
                + `<div class=ews-code-wrap data-type=css>`
                + ` <div class=wrap>div.dashboard-item-dashboarditemid {</div>`
                + ` <div class=ews-code-editor>`
                + `  <editor id=cssEditor name=cssEditor language=less data-type=css lib="UI/Editor"></editor>`
                + ` </div>`
                + ` <div class=wrap>}</div>`
                + `</div>`
                + `<div class=ews-code-wrap data-type=js>`
                + ` <div class=wrap>"use strict";</div>`
                + ` <div class=wrap><span style=color:#0000ff>function</span> CodeItemJsDashboardItemID(dashboardItem) {</div>`
                + ` <div class=ews-code-editor>`
                + `  <editor id=jsEditor name=jsEditor language=javascript data-type=js lib="UI/Editor"></editor>`
                + ` </div>`
                + ` <div class=wrap>}</div>`
                + `</div>`
                + `<div class=ews-code-wrap data-type=test>`
                + ` <div class=wrap><span style=color:#a31515>"use strict"</span>;</div>`
                + ` <div class=wrap>describe(<span style=color:#a31515>"Test Dashboard Item {DashboardItemID}"</span>, <span style=color:#0000ff>function</span> () {</div>`
                + ` <div class=ews-code-editor>`
                + `  <editor id=testEditor name=testEditor language=javascript data-type=test lib="UI/Editor"></editor>`
                + ` </div>`
                + ` <div class=wrap>}</div>`
                + `</div>`
                + `<div class=ews-code-wrap data-type=markdown>`
                + ` <div class=ews-code-tab-actions style=padding:5px>`
                + `  <div id=ews-code-guide-button class="ActionButtonContainer ActionButton"title="Markdown Guide">`
                + `   <div class="Title">Markdown Guide</div>`
                + `  </div>`
                + ` </div>`
                + ` <div class=ews-code-editor>`
                + `  <editor id=markdownEditor name=markdownEditor language=markdown data-type=markdown lib="UI/Editor"></editor>`
                + ` </div>`
                + `</div>`
                + `<div class=ews-code-wrap data-type=sdk>`
                + ` <div class=ews-code-editor>`
                // Task 954694: Make the UI Kit available in the SDK tab of Code Blocks
                + ` <iframe id=sdkPreview style=width:100%;height:100% src="about:blank"></iframe>`
                + ` </div>`
                + `</div>`
                + `</div>`
                + `<div class=ews-code-editor-split></div>`
                + `<div class=ews-code-preview><markdown id=markdownPreview style=display:none name=markdownPreview></markdown>`
                + `<div id=testScriptExample style=height:100%;width:100%;padding:20px;user-select:text;overflow:auto>`

                + `<div class="crossnote markdown-preview">`
                + `<style>code[class*=language-],pre[class*=language-]{color:var(--neutral-110);background:0 0;font-family:Consolas,"Liberation Mono",Menlo,Courier,monospace;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;word-wrap:normal;line-height:1.4;-moz-tab-size:8;-o-tab-size:8;tab-size:8;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none}pre[class*=language-]{padding:.8em;overflow:auto;border-radius:3px;background:#f5f5f5}:not(pre)>code[class*=language-]{padding:.1em;border-radius:.3em;white-space:normal;background:#f5f5f5}.token.blockquote,.token.comment{color:#969896}.token.cdata{color:#183691}.token.doctype,.token.macro.property,.token.punctuation,.token.variable{color:#333}.token.builtin,.token.important,.token.keyword,.token.operator,.token.rule{color:#a71d5d}.token.attr-value,.token.regex,.token.string,.token.url{color:#183691}.token.atrule,.token.boolean,.token.code,.token.command,.token.constant,.token.entity,.token.number,.token.property,.token.symbol{color:#0086b3}.token.prolog,.token.selector,.token.tag{color:#63a35c}.token.attr-name,.token.class,.token.class-name,.token.function,.token.id,.token.namespace,.token.pseudo-class,.token.pseudo-element,.token.url-reference .token.variable{color:#795da3}.token.entity{cursor:help}.token.title,.token.title .token.punctuation{font-weight:700;color:#1d3e81}.token.list{color:#ed6a43}.token.inserted{background-color:#eaffea;color:#55a532}.token.deleted{background-color:#ffecec;color:#bd2c00}.token.bold{font-weight:700}.token.italic{font-style:italic}.language-json .token.property{color:#183691}.language-markup .token.tag .token.punctuation{color:#333}.language-css .token.function,code.language-css{color:#0086b3}.language-yaml .token.atrule{color:#63a35c}code.language-yaml{color:#183691}.language-ruby .token.function{color:#333}.language-markdown .token.url{color:#795da3}.language-makefile .token.symbol{color:#795da3}.language-makefile .token.variable{color:#183691}.language-makefile .token.builtin{color:#0086b3}.language-bash .token.keyword{color:#0086b3}pre[data-line]{position:relative;padding:1em 0 1em 3em}pre[data-line] .line-highlight-wrapper{position:absolute;top:0;left:0;background-color:transparent;display:block;width:100%}pre[data-line] .line-highlight{position:absolute;left:0;right:0;padding:inherit 0;margin-top:1em;background:hsla(24,20%,50%,.08);background:linear-gradient(to right,hsla(24,20%,50%,.1) 70%,hsla(24,20%,50%,0));pointer-events:none;line-height:inherit;white-space:pre}pre[data-line] .line-highlight:before,pre[data-line] .line-highlight[data-end]:after{content:attr(data-start);position:absolute;top:.4em;left:.6em;min-width:1em;padding:0 .5em;background-color:hsla(24,20%,50%,.4);color:#f4f1ef;font:bold 65%/1.5 sans-serif;text-align:center;vertical-align:.3em;border-radius:999px;text-shadow:none;box-shadow:0 1px #fff}pre[data-line] .line-highlight[data-end]:after{content:attr(data-end);top:auto;bottom:.4em}#testScriptExample{font-family:'Helvetica Neue',Helvetica,'Segoe UI',Arial,freesans,sans-serif;font-size:16px;line-height:1.6;color:var(--neutral-110);background-color:#fff;overflow:initial;box-sizing:border-box;word-wrap:break-word}#testScriptExample>:first-child{margin-top:0}#testScriptExample h1,#testScriptExample h2,#testScriptExample h3,#testScriptExample h4,#testScriptExample h5,#testScriptExample h6{line-height:1.2;margin-top:1em;margin-bottom:16px;color:#000}#testScriptExample h1{font-size:2.25em;font-weight:300;padding-bottom:.3em}#testScriptExample h2{font-size:1.75em;font-weight:400;padding-bottom:.3em}#testScriptExample h3{font-size:1.5em;font-weight:500}#testScriptExample h4{font-size:1.25em;font-weight:600}#testScriptExample h5{font-size:1.1em;font-weight:600}#testScriptExample h6{font-size:1em;font-weight:600}#testScriptExample h1,#testScriptExample h2,#testScriptExample h3,#testScriptExample h4,#testScriptExample h5{font-weight:600}#testScriptExample h5{font-size:1em}#testScriptExample h6{color:#5c5c5c}#testScriptExample strong{color:#000}#testScriptExample del{color:#5c5c5c}#testScriptExample a:not([href]){color:inherit;text-decoration:none}#testScriptExample a{color:#08c;text-decoration:none}#testScriptExample a:hover{color:#00a3f5;text-decoration:none}#testScriptExample img{max-width:100%}#testScriptExample>p{margin-top:0;margin-bottom:16px;word-wrap:break-word}#testScriptExample>ol,#testScriptExample>ul{margin-bottom:16px}#testScriptExample ol,#testScriptExample ul{padding-left:2em}#testScriptExample ol.no-list,#testScriptExample ul.no-list{padding:0;list-style-type:none}#testScriptExample ol ol,#testScriptExample ol ul,#testScriptExample ul ol,#testScriptExample ul ul{margin-top:0;margin-bottom:0}#testScriptExample li{margin-bottom:0}#testScriptExample li.task-list-item{list-style:none}#testScriptExample li>p{margin-top:0;margin-bottom:0}#testScriptExample .task-list-item-checkbox{margin:0 .2em .25em -1.8em;vertical-align:middle}#testScriptExample .task-list-item-checkbox:hover{cursor:pointer}#testScriptExample blockquote{margin:16px 0;font-size:inherit;padding:0 15px;color:#5c5c5c;background-color:#f0f0f0;border-left:4px solid #d6d6d6}#testScriptExample blockquote>:first-child{margin-top:0}#testScriptExample blockquote>:last-child{margin-bottom:0}#testScriptExample hr{height:4px;margin:32px 0;background-color:#d6d6d6;border:0 none}#testScriptExample table th{font-weight:700;color:#000}#testScriptExample table td,#testScriptExample table th{border:1px solid #d6d6d6;padding:6px 13px}#testScriptExample dl{padding:0}#testScriptExample dl dt{padding:0;margin-top:16px;font-size:1em;font-style:italic;font-weight:700}#testScriptExample dl dd{padding:0 16px;margin-bottom:16px}#testScriptExample code{font-family:Menlo,Monaco,Consolas,'Courier New',monospace;font-size:.85em;color:var(--text);background-color:#f0f0f0;border-radius:3px;padding:.2em 0}#testScriptExample code::after,#testScriptExample code::before{letter-spacing:-.2em;content:'\\00a0'}#testScriptExample pre>code{padding:0;margin:0;word-break:normal;white-space:pre;background:0 0;border:0}#testScriptExample .highlight{margin-bottom:16px}#testScriptExample .highlight pre,#testScriptExample pre{padding:1em;overflow:auto;line-height:1.45;border:#d6d6d6;border-radius:3px}#testScriptExample .highlight pre{margin-bottom:0;word-break:normal}#testScriptExample pre code,#testScriptExample pre tt{display:inline;max-width:initial;padding:0;margin:0;overflow:initial;line-height:inherit;word-wrap:normal;background-color:transparent;border:0}#testScriptExample pre code:after,#testScriptExample pre code:before,#testScriptExample pre tt:after,#testScriptExample pre tt:before{content:normal}#testScriptExample blockquote,#testScriptExample dl,#testScriptExample ol,#testScriptExample p,#testScriptExample pre,#testScriptExample ul{margin-top:0;margin-bottom:16px}#testScriptExample kbd{color:var(--text);border:1px solid #d6d6d6;border-bottom:2px solid var(--neutral-40);padding:2px 4px;background-color:#f0f0f0;border-radius:3px}@media print{#testScriptExample{background-color:#fff}#testScriptExample h1,#testScriptExample h2,#testScriptExample h3,#testScriptExample h4,#testScriptExample h5,#testScriptExample h6{color:var(--text);page-break-after:avoid}#testScriptExample blockquote{color:#5c5c5c}#testScriptExample pre{page-break-inside:avoid}#testScriptExample table{display:table}#testScriptExample img{display:block;max-width:100%;max-height:100%}#testScriptExample code,#testScriptExample pre{word-wrap:break-word;white-space:pre}}.markdown-preview{width:100%;height:100%;box-sizing:border-box}.markdown-preview ul{list-style:disc}.markdown-preview ul ul{list-style:circle}.markdown-preview ul ul ul{list-style:square}.markdown-preview ol{list-style:decimal}.markdown-preview ol ol,.markdown-preview ul ol{list-style-type:lower-roman}.markdown-preview ol ol ol,.markdown-preview ol ul ol,.markdown-preview ul ol ol,.markdown-preview ul ul ol{list-style-type:lower-alpha}.markdown-preview .newpage,.markdown-preview .pagebreak{page-break-before:always}.markdown-preview pre.line-numbers{position:relative;padding-left:3.8em;counter-reset:linenumber}.markdown-preview pre.line-numbers>code{position:relative}.markdown-preview pre.line-numbers .line-numbers-rows{position:absolute;pointer-events:none;top:1em;font-size:100%;left:0;width:3em;letter-spacing:-1px;border-right:1px solid var(--neutral-50);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.markdown-preview pre.line-numbers .line-numbers-rows>span{pointer-events:none;display:block;counter-increment:linenumber}.markdown-preview pre.line-numbers .line-numbers-rows>span:before{content:counter(linenumber);color:var(--neutral-50);display:block;padding-right:.8em;text-align:right}.markdown-preview .mathjax-exps .MathJax_Display{text-align:center!important}.markdown-preview:not([data-for=preview]) .code-chunk .code-chunk-btn-group{display:none}.markdown-preview:not([data-for=preview]) .code-chunk .status{display:none}.markdown-preview:not([data-for=preview]) .code-chunk .output-div{margin-bottom:16px}.markdown-preview .md-toc{padding:0}.markdown-preview .md-toc .md-toc-link-wrapper .md-toc-link{display:inline;padding:.25rem 0}.markdown-preview .md-toc .md-toc-link-wrapper .md-toc-link div,.markdown-preview .md-toc .md-toc-link-wrapper .md-toc-link p{display:inline}.markdown-preview .md-toc .md-toc-link-wrapper.highlighted .md-toc-link{font-weight:800}.scrollbar-style::-webkit-scrollbar{width:8px}.scrollbar-style::-webkit-scrollbar-track{border-radius:10px;background-color:transparent}.scrollbar-style::-webkit-scrollbar-thumb{border-radius:5px;background-color:rgba(150,150,150,.66);border:4px solid rgba(150,150,150,.66);background-clip:content-box}#testScriptExample[for=html-export]:not([data-presentation-mode]){position:relative;width:100%;height:100%;top:0;left:0;margin:0;padding:0;overflow:auto}#testScriptExample[for=html-export]:not([data-presentation-mode]) .markdown-preview{position:relative;top:0;min-height:100vh}@media screen and (min-width:914px){#testScriptExample[for=html-export]:not([data-presentation-mode]) .markdown-preview{padding:2em calc(50% - 457px + 2em)}}@media screen and (max-width:914px){#testScriptExample[for=html-export]:not([data-presentation-mode]) .markdown-preview{padding:2em}}@media screen and (max-width:450px){#testScriptExample[for=html-export]:not([data-presentation-mode]) .markdown-preview{font-size:14px!important;padding:1em}}@media print{#testScriptExample[for=html-export]:not([data-presentation-mode]) #sidebar-toc-btn{display:none}}#testScriptExample[for=html-export]:not([data-presentation-mode]) #sidebar-toc-btn{position:fixed;bottom:8px;left:8px;font-size:28px;cursor:pointer;color:inherit;z-index:99;width:32px;text-align:center;opacity:.4}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] #sidebar-toc-btn{opacity:1}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc{position:fixed;top:0;left:0;width:300px;height:100%;padding:32px 0 48px 0;font-size:14px;box-shadow:0 0 4px rgba(150,150,150,.33);box-sizing:border-box;overflow:auto;background-color:inherit}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc::-webkit-scrollbar{width:8px}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc::-webkit-scrollbar-track{border-radius:10px;background-color:transparent}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc::-webkit-scrollbar-thumb{border-radius:5px;background-color:rgba(150,150,150,.66);border:4px solid rgba(150,150,150,.66);background-clip:content-box}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc a{text-decoration:none}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc .md-toc{padding:0 16px}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc .md-toc .md-toc-link-wrapper .md-toc-link{display:inline;padding:.25rem 0}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc .md-toc .md-toc-link-wrapper .md-toc-link div,#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc .md-toc .md-toc-link-wrapper .md-toc-link p{display:inline}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .md-sidebar-toc .md-toc .md-toc-link-wrapper.highlighted .md-toc-link{font-weight:800}#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .markdown-preview{left:300px;width:calc(100% - 300px);padding:2em calc(50% - 457px - 300px / 2);margin:0;box-sizing:border-box}@media screen and (max-width:1274px){#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .markdown-preview{padding:2em}}@media screen and (max-width:450px){#testScriptExample[for=html-export]:not([data-presentation-mode])[html-show-sidebar-toc] .markdown-preview{width:100%}}#testScriptExample[for=html-export]:not([data-presentation-mode]):not([html-show-sidebar-toc]) .markdown-preview{left:50%;transform:translateX(-50%)}#testScriptExample[for=html-export]:not([data-presentation-mode]):not([html-show-sidebar-toc]) .md-sidebar-toc{display:none}</style>`
                + `<h1 id="test-scripts">Test Scripts </h1>`
                + `<p>Test Scripts are required to release any Dashboard with a Code Block that contains JavaScript.</p>`
                + `<p>Test Scripts must hit a minimum of 80% <strong>Statement</strong> coverage.</p>`
                + `<h2 id="things-to-know">Things to Know </h2>`
                + `<ul>`
                + `<li>Put the corresponding code in the correct code tab`
                + `<ul>`
                + `<li>i.e. Don't put JavaScript in a <code>&lt;script&gt;</code> tag in the HTML tab</li>`
                + `</ul>`
                + `</li>`
                + `<li>The HTML tab contents do NOT have access to the JavaScript file directly`
                + `<ul>`
                + `<li>This means you cannot create <code>&lt;input&gt;</code> tags with built-in onclick/onchange/etc. events</li>`
                + `<li>To set event listeners use <a href="https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector"><code>document.querySelector</code></a> or <a href="https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementbyid"><code>document.getElementById</code></a> to get the element then call <a href="https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener"><code>element.addEventListener</code></a></li>`
                + `</ul>`
                + `</li>`
                + `<li>The test scripts use the <a href="https://www.chaijs.com/api/assert/">Chai Assert APIs</a> and the <a href="https://mochajs.org/">Mocha testing framework</a></li>`
                + `<li>Tests run sequentially, in the order they are written</li>`
                + `<li>You cannot debug test scripts`
                + `<ul>`
                + `<li>If a test script is failing for an unknown reason try using <code>console.log</code> to see data during the test (make sure to remove once done)</li>`
                + `<li><code>console.log</code> can only be used in the Test Script tab, it cannot be in the JavaScript tab otherwise the test won't run due to an error</li>`
                + `</ul>`
                + `</li>`
                + `<li>Test scripts will fail if the page is unloaded for some reason (redirect on click for example)`
                + `<ul>`
                + `<li>Make sure the actual redirect is not run during the test</li>`
                + `</ul>`
                + `</li>`
                + `<li>Use <code>EC_Fmt.TriggerEvent</code> to trigger specific events on elements during testing`
                + `<ul>`
                + `<li>Most commonly used for UI based tests</li>`
                + `</ul>`
                + `</li>`
                + `</ul>`
                + `<h2 id="best-practices">Best Practices </h2>`
                + `<ul>`
                + `<li>Write test cases for as much code as possible`
                + `<ul>`
                + `<li>80% is the minimum allowed but should not be the goal</li>`
                + `</ul>`
                + `</li>`
                + `<li>Don't write test scripts without at least 1 <code>assert</code> call`
                + `<ul>`
                + `<li>This may require some refactoring of JavaScript tab code to return data to check against</li>`
                + `<li>Check DOM changes when testing UI</li>`
                + `<li>Async tests with <code>done</code> are an exception</li>`
                + `</ul>`
                + `</li>`
                + `<li>Avoid calling APIs, downloading files, prompting to print, etc. in test scripts`
                + `<ul>`
                + `<li>APIs take more time to run and typically the result is all that is needed</li>`
                + `<li>Create test results and put those in the test scripts to feed into tests</li>`
                + `<li>Use a "is testing" variable to know when tests are running; if running don't call the APIs (example below)</li>`
                + `</ul>`
                + `</li>`
                + `<li>Keep test cases simple and focused`
                + `<ul>`
                + `<li>Don't test multiple things in a single test</li>`
                + `</ul>`
                + `</li>`
                + `<li>If using manual delays in test scripts, modify the test's expected slow time to avoid timeouts and false flags of slowness`
                + `<ul>`
                + `<li>See <a href="https://mochajs.org/#test-duration">Mocha's test duration info</a> for more information</li>`
                + `<li>Example below</li>`
                + `</ul>`
                + `</li>`
                + `<li>If testing UI changes (dialog opening, text changing, etc.) query the DOM for the effected elements and <code>assert</code> the changes you expect those elements to have</li>`
                + `</ul>`
                + `<h2 id="definitions">Definitions </h2>`
                + `<ul>`
                + `<li><code>describe</code> - Function called to describe a set of test scripts`
                + `<ul>`
                + `<li>Could be a specific function or a workflow</li>`
                + `<li>Dictates how the final test results are grouped</li>`
                + `</ul>`
                + `</li>`
                + `<li><code>it</code> - Function called to perform a particular test`
                + `<ul>`
                + `<li>Typically nested inside <code>describe</code> calls but can be by themselves</li>`
                + `</ul>`
                + `</li>`
                + `<li><code>assert</code> - Used to confirm test script values are expected`
                + `<ul>`
                + `<li>Will fail a test script if the assert fails</li>`
                + `</ul>`
                + `</li>`
                + `</ul>`
                + `<h2 id="templatesexamples">Templates/Examples </h2>`
                + `<h3 id="basic">Basic </h3>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>const assert = chai.assert;&#10;`
                + `&#10;`
                + `describe("Some Function", () =&gt; {&#10;`
                + `    it("will do this", () =&gt; {&#10;`
                + `        const TestData = {&#10;`
                + `            Test: "abc"&#10;`
                + `        };&#10;`
                + `&#10;`
                + `        const result = SomeFunction(TestData);&#10;`
                + `&#10;`
                + `        assert.equal(result, "cba", "result should be reversed");&#10;`
                + `    });&#10;`
                + `});&#10;`
                + `;&#10;`
                + `</code></pre><h3 id="debug-variable">Debug Variable </h3>`
                + `<p>JavaScript tab</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>// At the top&#10;`
                + `let TestsAreRunning = false;&#10;`
                + `&#10;`
                + `function Enable_Testing() {&#10;`
                + `    TestsAreRunning = true;&#10;`
                + `}&#10;`
                + `&#10;`
                + `[...]&#10;`
                + `&#10;`
                + `// inside a function that redirects or calls an API&#10;`
                + `const myRequest = new EC_Request("SomeAPICommand")&#10;`
                + `&#10;`
                + `if (!TestsAreRunning) {&#10;`
                + `    myRequest.submit()&#10;`
                + `}&#10;`
                + `</code></pre><p>Test Script tab</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>const assert = chai.assert;&#10;`
                + `&#10;`
                + `before(() =&gt; {&#10;`
                + `    Enable_Testing();&#10;`
                + `});&#10;`
                + `&#10;`
                + `describe("Some Function", () =&gt; {&#10;`
                + `    it("will do this", () =&gt; {&#10;`
                + `        const TestData = {&#10;`
                + `            Test: "abc"&#10;`
                + `        };&#10;`
                + `&#10;`
                + `        const result = SomeFunction(TestData);&#10;`
                + `&#10;`
                + `        assert.equal(result, "cba", "result should be reversed");&#10;`
                + `    });&#10;`
                + `});&#10;`
                + `&#10;`
                + `</code></pre><h3 id="manual-delay">Manual Delay </h3>`
                + `<p>This is typically used when waiting for a UI action to occur and checking results of that action</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>const assert = chai.assert;&#10;`
                + `&#10;`
                + `describe("Some Function", () =&gt; {&#10;`
                + `    it("will open a dialog", async () =&gt; {&#10;`
                + `        // FAST = slow/2&#10;`
                + `        // We are waiting 1 seconds always, default is 75ms&#10;`
                + `        this.slow(2075);&#10;`
                + `&#10;`
                + `        const TestData = {&#10;`
                + `            Test: "abc"&#10;`
                + `        };&#10;`
                + `&#10;`
                + `        SomeFunction(TestData);&#10;`
                + `        &#10;`
                + `        // Wait 1 second to make sure dialog has time to popup&#10;`
                + `        await delay(1000);&#10;`
                + `&#10;`
                + `        assert.isTrue(Dialog_IsShowing(), "dialog should be showing");&#10;`
                + `        assert.equal(Get_OnScreen_Dialog_Title(), TestData.Test, "dialog title should match passed in data");&#10;`
                + `    });&#10;`
                + `&#10;`
                + `    after(() =&gt; {&#10;`
                + `        // Cleanup any open dialogs after the test&#10;`
                + `        Click_CloseButton_On_ShowingDialogs();&#10;`
                + `    })&#10;`
                + `});&#10;`
                + `</code></pre><h3 id="ui-test">UI Test </h3>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>const assert = chai.assert;&#10;`
                + `&#10;`
                + `describe("Clicking the open dialog button", () =&gt; {&#10;`
                + `    it("will open a dialog when valid data set", async () =&gt; {&#10;`
                + `        // FAST = slow/2&#10;`
                + `        // We are waiting 1 seconds always, default is 75ms&#10;`
                + `        this.slow(2075);&#10;`
                + `&#10;`
                + `        const ValidData = {&#10;`
                + `            Test: "abc"&#10;`
                + `        };&#10;`
                + `&#10;`
                + `        UpdateFormData(ValidData);&#10;`
                + `&#10;`
                + `        EC_Fmt.TriggerEvent(document.getElementById("my-button"), "click", { bubbles: true });&#10;`
                + `        &#10;`
                + `        // Wait 1 second to make sure dialog has time to popup&#10;`
                + `        await delay(1000);&#10;`
                + `&#10;`
                + `        assert.isTrue(Dialog_IsShowing(), "dialog should be showing");&#10;`
                + `        assert.equal(Get_OnScreen_Dialog_Title(), ValidData.Test, "dialog title should match passed in data");&#10;`
                + `    });&#10;`
                + `&#10;`
                + `    it("will not open a dialog with inputs when valid data set", async () =&gt; {&#10;`
                + `        // FAST = slow/2&#10;`
                + `        // We are waiting 1 seconds always, default is 75ms&#10;`
                + `        this.slow(2075);&#10;`
                + `&#10;`
                + `        const InvalidData;&#10;`
                + `&#10;`
                + `        UpdateFormData(InvalidData);&#10;`
                + `&#10;`
                + `        EC_Fmt.TriggerEvent(document.getElementById("my-button"), "click", { bubbles: true });&#10;`
                + `        &#10;`
                + `        // Wait 1 second to make sure dialog has time to popup&#10;`
                + `        await delay(1000);&#10;`
                + `&#10;`
                + `        assert.isFalse(Dialog_IsShowing(), "dialog should not be showing");&#10;`
                + `        assert.isTrue(document.querySelector("input[name=my-input]").hasAttribute("error"), "input should be in error");&#10;`
                + `    });&#10;`
                + `&#10;`
                + `    after(() =&gt; {&#10;`
                + `        // Cleanup any open dialogs after the test&#10;`
                + `        Click_CloseButton_On_ShowingDialogs();&#10;`
                + `    })&#10;`
                + `});;&#10;`
                + `</code></pre><h3 id="asynchronous-tests">Asynchronous Tests </h3>`
                + `<p>See <a href="https://mochajs.org/#asynchronous-code">Mocha's Asynchronous Code</a> for more information about <code>done</code></p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>const assert = chai.assert;&#10;`
                + `&#10;`
                + `describe("Async Functions", () =&gt; {&#10;`
                + `    // passing in a callback&#10;`
                + `    // testing will wait until done() is called&#10;`
                + `    it("will work without failing", (done) =&gt; {&#10;`
                + `        SomeFunction((error) =&gt; {&#10;`
                + `            if (error) {&#10;`
                + `                done(error);&#10;`
                + `            } else {&#10;`
                + `                done();&#10;`
                + `            }&#10;`
                + `        });&#10;`
                + `    });&#10;`
                + `&#10;`
                + `    // Asserting with a returned Promise&#10;`
                + `    it("will return a promise with the correct results", (done) =&gt; {&#10;`
                + `        return SomeFunction().then((data) =&gt; {&#10;`
                + `            assert.equal(data.value, "1234", "function returns 1234");&#10;`
                + `        });&#10;`
                + `    });&#10;`
                + `&#10;`
                + `    // Awaiting a promise&#10;`
                + `    it("will return correct results", async (done) =&gt; {&#10;`
                + `        const Data = await SomeFunction();&#10;`
                + `&#10;`
                + `        assert.equal(Data.value, "1234", "function returns 1234");&#10;`
                + `    });&#10;`
                + `});&#10;`
                + `&#10;`
                + `</code></pre><h2 id="helpful-functions">Helpful Functions </h2>`
                + `<h3 id="delaymilliseconds"><code>delay(milliseconds)</code> </h3>`
                + `<p>Halts execution for the specified <code>milliseconds</code></p>`
                + `<ul>`
                + `<li><code>milliseconds: number</code> Number of milliseconds to wait for</li>`
                + `</ul>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>function delay(milliseconds) {&#10;`
                + `    return new Promise(res =&gt; setTimeout(res, milliseconds));&#10;`
                + `};&#10;`
                + `</code></pre><p>Example</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>// wait for 1 second&#10;`
                + `await delay(1000);&#10;`
                + `</code></pre><h3 id="click_confirmbutton_on_showingdialogs"><code>Click_ConfirmButton_On_ShowingDialogs()</code> </h3>`
                + `<p>Click the <strong>confirm</strong> button on all showing dialogs</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>function Click_ConfirmButton_On_ShowingDialogs() {&#10;`
                + `    const dialogs = document.querySelectorAll(".ecp-dialog");&#10;`
                + `    for (let i = 0; i &lt; dialogs.length; ++i) {&#10;`
                + `        // Find dialogs that are still showing&#10;`
                + `        if (dialogs[i].style.display !== "none") {&#10;`
                + `            EC_Fmt.TriggerEvent(dialogs[i].querySelector(".ecp-dialog-confirm-button"), "click", { bubbles: true });&#10;`
                + `        }&#10;`
                + `    }&#10;`
                + `}&#10;`
                + `</code></pre><p>Example</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>SomeFunctionThatOpenDialog();&#10;`
                + `// wait for the dialog to show up&#10;`
                + `await delay(1000);&#10;`
                + `&#10;`
                + `// Click confirm to test the confirm action on a dialog&#10;`
                + `Click_ConfirmButton_On_ShowingDialogs();`
                + `</code></pre><h3 id="click_closebutton_on_showingdialogs"><code>Click_CloseButton_On_ShowingDialogs()</code> </h3>`
                + `<p>Click the <strong>close</strong> button (top-right X button) on all showing dialogs</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>function Click_CloseButton_On_ShowingDialogs() {&#10;`
                + `    const Dialogs = document.querySelectorAll(".ecp-dialog");&#10;`
                + `&#10;`
                + `    for (let i = 0; i &lt; Dialogs.length; ++i) {&#10;`
                + `        // Find dialogs that are still showing&#10;`
                + `        if (Dialogs[i].style.display !== "none") {&#10;`
                + `            EC_Fmt.TriggerEvent(Dialogs[i].querySelector(".ecp-dialog-close"), "click", { bubbles: true });&#10;`
                + `        }&#10;`
                + `    }&#10;`
                + `}`
                + `</code></pre><p>Example</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>// close all opened dialogs after test cases run before the next set&#10;`
                + `after(() =&gt; {&#10;`
                + `    // Click confirm to test the confirm action on a dialog&#10;`
                + `    Click_CloseButton_On_ShowingDialogs();&#10;`
                + `});`
                + `</code></pre><h3 id="dialog_isshowing"><code>Dialog_IsShowing()</code> </h3>`
                + `<p>Determines if there is a dialog currently displayed during tests</p>`
                + `<ul>`
                + `<li>Returns: <code>boolean</code> <code>true</code> if a dialog is on screen, <code>false</code> if no dialog is showing</li>`
                + `</ul>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>function Dialog_IsShowing() {&#10;`
                + `    const dialogs = document.querySelectorAll(".ecp-dialog");&#10;`
                + `    for (let i = 0; i &lt; dialogs.length; ++i) {&#10;`
                + `        // Find dialogs that are still showing&#10;`
                + `        if (dialogs[i].style.display !== "none") {&#10;`
                + `            return true;&#10;`
                + `        }&#10;`
                + `    }&#10;`
                + `    return false;&#10;`
                + `}`
                + `</code></pre><p>Example</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>SomeFunctionThatOpenDialog();&#10;`
                + `// wait for the dialog to show up&#10;`
                + `await delay(1000);&#10;`
                + `&#10;`
                + `assert.isTrue(Dialog_IsShowing(), "dialog should be showing");`
                + `</code></pre><h3 id="get_onscreen_dialog"><code>Get_OnScreen_Dialog()</code> </h3>`
                + `<p>Gets the <strong>first</strong> showing dialog and returns the whole <code>Element</code></p>`
                + `<ul>`
                + `<li>Returns: <code>Element</code> The first showing dialog element, containing header, contents, and buttons; <code>null</code> otherwise</li>`
                + `</ul>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>function Get_OnScreen_Dialog() {&#10;`
                + `    const dialogs = document.querySelectorAll(".ecp-dialog");&#10;`
                + `    for (let i = 0; i &lt; dialogs.length; ++i) {&#10;`
                + `        // Find dialogs that are still showing&#10;`
                + `        if (dialogs[i].style.display !== "none") {&#10;`
                + `            return dialogs[i];&#10;`
                + `        }&#10;`
                + `    }&#10;`
                + `    return null;&#10;`
                + `}`
                + `</code></pre><p>Example</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>SomeFunctionThatOpenDialog();&#10;`
                + `// wait for the dialog to show up&#10;`
                + `await delay(1000);&#10;`
                + `&#10;`
                + `const OpenDialog = Get_OnScreen_Dialog();&#10;`
                + `&#10;`
                + `assert.exists(OpenDialog.querySelector("[name=SomeName]"), "dialog should be open");`
                + `</code></pre><h3 id="get_onscreen_dialog_title"><code>Get_OnScreen_Dialog_Title()</code> </h3>`
                + `<p>Returns the title string of the <strong>first</strong> showing dialog</p>`
                + `<ul>`
                + `<li>Returns: <code>string</code> The title of first found open dialog; "" (empty string) returned if no Dialog found</li>`
                + `</ul>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>function Get_OnScreen_Dialog_Title() {&#10;`
                + `    const dialogs = document.querySelectorAll(".ecp-dialog");&#10;`
                + `    for (let i = 0; i &lt; dialogs.length; ++i) {&#10;`
                + `        // Find dialogs that are still showing&#10;`
                + `        if (dialogs[i].style.display !== "none") {&#10;`
                + `            return dialogs[i].querySelector(".ecp-dialog-title").innerText;&#10;`
                + `        }&#10;`
                + `    }&#10;`
                + `    return "";&#10;`
                + `}&#10;`
                + ``
                + `</code></pre><p>Example</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>SomeFunctionThatOpenDialog();&#10;`
                + `// wait for the dialog to show up&#10;`
                + `await delay(1000);&#10;`
                + `&#10;`
                + `assert.equal(Get_OnScreen_Dialog_Title(), "My Dialog Title", "title should match");`
                + `</code></pre><h3 id="get_onscreen_dialog_content"><code>Get_OnScreen_Dialog_Content()</code> </h3>`
                + `<p>Returns the innerHTML string of the content of the <strong>first</strong> open dialog<br>`
                + `Used for simple dialog content checking</p>`
                + `<ul>`
                + `<li>Returns: <code>string</code> The innerHTML of the found dialog</li>`
                + `</ul>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>function Get_OnScreen_Dialog_Content() {&#10;`
                + `    const dialogs = document.querySelectorAll(".ecp-dialog");&#10;`
                + `    for (let i = 0; i &lt; dialogs.length; ++i) {&#10;`
                + `        // Find dialogs that are still showing&#10;`
                + `        if (dialogs[i].style.display !== "none") {&#10;`
                + `            return dialogs[i].querySelector(".ecp-dialog-content div").innerHTML;&#10;`
                + `        }&#10;`
                + `    }&#10;`
                + `    return "";&#10;`
                + `}`
                + `</code></pre><p>Example</p>`
                + `<pre data-role="codeBlock" data-info="" class="language-text"><code>SomeFunctionThatOpenDialog();&#10;`
                + `// wait for the dialog to show up&#10;`
                + `await delay(1000);&#10;`
                + `&#10;`
                + `assert.equal(Get_OnScreen_Dialog_Content(), "Are you sure you want to do this action?", "contents should match");`
                + `</code></pre>`
                + `</div>`
                + `</div></div>`
                + `</div>`
                + `</div>`
                + `</div>`;

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;

            me.EditorContainer = tempDiv.firstChild;
            document.body.appendChild(me.EditorContainer);

            // Close
            me.EditorContainer.querySelector("#ews-code-cancel-button").addEventListener("click", () => {
                // Task 669407: If another person has a code block open and is working on it, warn subsequent users when they open the code block to avoid changes over-writing eachother
                if (dashboardItem && EC_Fmt.isInteger(dashboardItem.id)) {
                    fetch(`api?APICommand=Dashboard_MarkCodeBlockClosed&DashboardItemID=${dashboardItem.id}`, { credentials: "same-origin" });
                }
                me.CloseEditor();
            });

            // Open/Close Preview
            me.EditorContainer.querySelector("#ews-code-preview-button").addEventListener("click", function () {
                me.TogglePreview(this);
            });

            // Split
            me.EditorContainer.addEventListener("mousemove", (mouseEvent) => {
                if (me.isSplitMove) {
                    const previewWidth = mouseEvent.pageX / parseInt(getComputedStyle(me.EditorContainer).width.replace("px", ""), 10);
                    me.EditorContainer.querySelector(".ews-code-autofix").style.right = `${(1 - previewWidth) * 100}%`;
                    me.EditorContainer.querySelector(".ews-code-editors").style.right = `${(1 - previewWidth) * 100}%`;
                    me.EditorContainer.querySelector(".ews-code-preview").style.left = `${previewWidth * 100}%`;
                    me.EditorContainer.querySelector(".ews-code-editor-split").style.left = `${previewWidth * 100}%`;
                }
            });

            me.EditorContainer.querySelector(".ews-code-editor-split").addEventListener("mousedown", () => {
                me.isSplitMove = true;
                const iFrames = me.EditorContainer.querySelectorAll("iframe");
                for (let i = 0; i < iFrames.length; i++) {
                    iFrames[i].style.pointerEvents = "none";
                }
            });

            document.addEventListener("mouseup", () => {
                me.isSplitMove = false;
                const iFrames = me.EditorContainer.querySelectorAll("iframe");
                for (let i = 0; i < iFrames.length; i++) {
                    iFrames[i].style.pointerEvents = "auto";
                }
            });

            // Refresh Preview
            me.EditorContainer.querySelector("#ews-code-refresh-button").addEventListener("click", () => {
                // Task 939222: Refresh the session whenever clicking refresh preview in the code block
                EWS.VerifySession(() => {
                    me.RefreshPreview();
                });
            });

            // Save Code
            me.EditorContainer.querySelector("#ews-code-save-button").addEventListener("click", () => {
                // Task 669407: If another person has a code block open and is working on it, warn subsequent users when they open the code block to avoid changes over-writing eachother
                if (dashboardItem && EC_Fmt.isInteger(dashboardItem.id)) {
                    fetch(`api?APICommand=Dashboard_MarkCodeBlockClosed&DashboardItemID=${dashboardItem.id}`, { credentials: "same-origin" });
                }
                me.SaveCode({
                    closeEditor: true,
                    callCallback: true
                });
            });

            // Test Code
            me.EditorContainer.querySelector("#ews-code-runtest-button").addEventListener("click", () => {
                if (!me.ValidateTestCode()) {
                    return;
                }

                // Task 946448: Prevent developers from using window.console.log() to by-pass the 80% code coverage requirement
                // Check ESLint Error
                const {
                    errors
                } = me.CodeEditors.jsEditor;

                if (errors?.length > 0) {
                    ECP.Dialog.ShowDialog("Javascript Code Error", `<div style=margin:auto>The javascript code has ${errors.length} error${errors.length > 1 ? "s" : ""}. Please correct the code first.</div>`, {
                        confirmButtonTitle: "OK"
                    });

                    return;
                }

                const def = Deferred();

                me.SaveCode({
                    deferred: def
                });

                def.then(() => {
                    TabCodeEditor.RunTest(Object.assign({}, me.Options.itemFields, {
                        isGlobal: me.Options.isGlobal,
                        loadingCover: ".ews-code-container",
                        tabCodeEditor: me
                    })).catch(() => {
                        // this is the testing script, catch test errors here
                    });
                });
            });

            // Generate AI Test Script
            const generateTestScriptBtn = me.EditorContainer.querySelector("#ews-code-generateAITestScript-button");
            let countDown = 0;
            function ensureSecondLine(text) {
                const requiredLines = ["/* eslint-disable */", "var assert = chai.assert;"];
                const lines = text.split("\n");
                requiredLines.forEach((line, index) => {
                    if (lines[index] !== line) {
                        lines.splice(index, 0, line);
                    }
                });
                return lines.join("\n");
            }
            generateTestScriptBtn.addEventListener("click", async () => {
                const myJSEditors = me.CodeEditors.jsEditor.editor.monacoEditor;
                const selection = myJSEditors.getSelection();
                const jsSelectedText = myJSEditors.getModel().getValueInRange(selection);
                if (EC_Fmt.isNull(jsSelectedText)) {
                    ECP.Dialog.ShowDialog(
                        "Generate AI Test Script Error",
                        "<div style=margin:auto>Please select the snippet containing the Javascript code.</div>",
                        {
                            confirmButtonTitle: "OK"
                        }
                    );
                    return;
                }
                if (EC_Fmt.isNull(me.CodeEditors.testEditor.code) && !me.CodeEditors.testEditor.code.startsWith("/* eslint-disable */")) {
                    me.CodeEditors.testEditor.code = ensureSecondLine(me.CodeEditors.testEditor.code);
                }
                const { errors } = me.CodeEditors.jsEditor;

                if (errors?.length > 0) {
                    ECP.Dialog.ShowDialog(
                        "Javascript Code Error",
                        `<div style=margin:auto>The javascript code has ${errors.length
                        } error${errors.length > 1 ? "s" : ""
                        }. Please correct the code first.</div>`,
                        {
                            confirmButtonTitle: "OK"
                        }
                    );
                    return;
                }
                if (countDown === 0) {
                    me.EditorContainer.querySelector(`.ews-code-tabs .ews-code-tab[data-type='test'] span`).click();
                    ECP.Dialog.ShowDialog(
                        "Generate AI Test Script",
                        "This code was generated by an AI and may contain errors or inefficiencies. Please thoroughly review and test it before use.",
                        {
                            confirmButtonTitle: "Confirm",
                            cancelButtonTitle: "Cancel",
                            confirmButtonAction: async () => {
                                ECP.Dialog.ShowLoading("Generating...", ".ews-code-container");
                                try {
                                    const result = await generateAITestScript(
                                        me.Options.itemFields.GlobalHtmlDocumentID,
                                        me.Options.itemFields.GlobalCssDocumentID,
                                        me.Options.itemFields.GlobalJsDocumentID,
                                        jsSelectedText
                                    );
                                    if (!EC_Fmt.isNull(result)) {
                                        me.CodeEditors.testEditor.code += `\n${result}`;
                                        countDown = 60;
                                    } else {
                                        ECP.Dialog.ShowDialog("Generate AI", "Failure to generate test code through the AI LLM");
                                    }
                                } catch (error) {
                                    ECP.Dialog.ShowDialog("Generate AI", "Failure to generate test code through the AI LLM");
                                }
                                generateTestScriptBtn.disabled = true;
                                generateTestScriptBtn.innerText = `Generate AI Test Script (${countDown}s)`;
                                const interval = setInterval(() => {
                                    countDown--;
                                    generateTestScriptBtn.innerText = `Generate AI Test Script (${countDown}s)`;
                                    if (countDown <= 0) {
                                        clearInterval(interval);
                                        generateTestScriptBtn.disabled = false;
                                        generateTestScriptBtn.innerText = `Generate AI Test Script`;
                                    }
                                }, 1000);
                                ECP.Dialog.HideLoading();
                            }
                        }
                    );
                }
            });

            // Commit to Git With Message
            me.EditorContainer.querySelector("#ews-code-commit-button").addEventListener("click", () => {
                const changed = Array.from(me.EditorContainer.querySelectorAll(`.ews-code-tabs .ews-code-tab span`)).some(tabSpan => tabSpan.innerHTML.includes("*"));

                const dialogContent = "<fieldset class=ews-code-message-fieldset>"
                    + "<legend>Commit Message</legend>"
                    + "<textarea class=ews-code-message></textarea>"
                    + "</fieldset>";

                const dialog = ECP.Dialog.ShowDialog("Save With Commit Message", dialogContent, {
                    confirmButtonTitle: "Save",
                    confirmButtonAction: async () => {
                        const message = dialog.querySelector(".ews-code-message").value.trim();

                        if (changed) {
                            await me.SaveCode({ message });
                        }

                        const DashboardDocuments = [];

                        if (me.Options.itemFields.GlobalHtmlDocumentID) {
                            DashboardDocuments.push({
                                Type: DashboardDocumentType.HTML,
                                GlobalDocumentID: me.Options.itemFields.GlobalHtmlDocumentID
                            });
                        }

                        if (me.Options.itemFields.GlobalCssDocumentID) {
                            DashboardDocuments.push({
                                Type: DashboardDocumentType.CSS,
                                GlobalDocumentID: me.Options.itemFields.GlobalCssDocumentID
                            });
                        }

                        if (me.Options.itemFields.GlobalJsDocumentID) {
                            DashboardDocuments.push({
                                Type: DashboardDocumentType.Javascript,
                                GlobalDocumentID: me.Options.itemFields.GlobalJsDocumentID
                            });
                        }

                        if (me.Options.itemFields.GlobalTestDocumentID) {
                            DashboardDocuments.push({
                                Type: DashboardDocumentType.TestScript,
                                GlobalDocumentID: me.Options.itemFields.GlobalTestDocumentID
                            });
                        }

                        if (me.Options.itemFields.GlobalMarkdownDocumentID) {
                            DashboardDocuments.push({
                                Type: DashboardDocumentType.Markdown,
                                GlobalDocumentID: me.Options.itemFields.GlobalMarkdownDocumentID
                            });
                        }

                        const DashboardCodeItemData = [];
                        DashboardCodeItemData.push({ DashboardDocuments });

                        await CommitCodeDocument(Settings.DashboardID, Settings.DashboardVersionID, DashboardCodeItemData, message);
                        ECP.Dialog.HideLoading();
                    }
                });
            });

            // View History
            me.EditorContainer.querySelector("#ews-code-viewHistory-button").addEventListener("click", () => {
                const currentType = me.EditorContainer.querySelector(".ews-code-tab.ews-code-tab-selected").dataset.type;
                const currentEditor = me.EditorContainer.querySelector(`.ews-code-editors editor[data-type='${currentType}']`);

                if (currentEditor) {
                    me.ViewHistory(currentEditor);
                }
            });

            // Auto Fix js Code
            me.EditorContainer.querySelector(".ews-code-autofix").addEventListener("click", () => {
                me.CodeEditors.jsEditor.fix();
            });
            me.EditorContainer.querySelector("#ews-code-guide-button").addEventListener("click", () => {
                const markdownGuideData = [
                    {
                        title: "Headings",
                        examples: [
                            {
                                type: "Heading 1",
                                example: "# Heading 1",
                                prefix: "# ",
                                height: 100
                            },
                            {
                                type: "Heading 2",
                                example: "## Heading 2",
                                prefix: "## ",
                                height: 90
                            },
                            {
                                type: "Heading 3",
                                example: "### Heading 3",
                                prefix: "### "
                            },
                            {
                                type: "Heading 4",
                                example: "#### Heading 4",
                                prefix: "#### "
                            },
                            {
                                type: "Heading 5",
                                example: "##### Heading 5",
                                prefix: "##### "
                            },
                            {
                                type: "Heading 6",
                                example: "###### Heading 6",
                                prefix: "###### "
                            }
                        ]
                    },
                    {
                        title: "Text Formatting",
                        examples: [
                            {
                                type: "Bold",
                                example: "**Bold Text**",
                                prefix: "**",
                                suffix: "**"
                            },
                            {
                                type: "Italic",
                                example: "*Italicized  Text*",
                                prefix: "*",
                                suffix: "*"
                            },
                            {
                                type: "Code",
                                example: "`var myVariable;`",
                                prefix: "`",
                                suffix: "`"
                            },
                            {
                                type: "Link",
                                example: "[Title of Link](https://www.google.com)",
                                prefix: "[](",
                                suffix: ")"
                            },
                            {
                                type: "Image",
                                example: "![Alternate Text](https://cdn.e8.co/GlobalDocs/580188.svg)",
                                prefix: "![](",
                                suffix: ")",
                                height: 255
                            }
                        ]
                    },
                    {
                        title: "Section Formatting",
                        examples: [
                            {
                                type: "Horizontal Rule",
                                example: "---",
                                prefix: "---\n"
                            },
                            {
                                type: "Block Quote",
                                example: "> This is a Quote",
                                prefix: "> "
                            },
                            {
                                type: "Ordered List",
                                example: "1. Item One\n<br>2. Item Two\n<br>3. Item Three",
                                prefix: "1. ",
                                height: 120
                            },
                            {
                                type: "Unordered List",
                                example: "- Item One\n<br>- Item Two\n<br>- Item Three",
                                prefix: "- ",
                                height: 120
                            },
                            {
                                type: "Fenced Code",
                                example: "```\n<br>{\n<br>&emsp;\"variable1\":\"value1\",\n<br>&emsp;\"variable2\":\"value2\"\n<br>}\n<br>```",
                                prefix: "```\n",
                                suffix: "\n```",
                                height: 150
                            },
                            {
                                type: "Table",
                                example: "|Col1|Col2|Col3|\n<br>|----|----|----|\n<br>| a1 |  a2 | a3 |\n<br>| b1 |  b2 | b3 |\n<br>| c1 |  c2 | c3 |",
                                prefix: "|",
                                suffix: "||\n|----|----|\n| | |",
                                height: 200
                            }
                        ]
                    }
                ];
                let htmlB = "";
                for (let i = 0; i < markdownGuideData.length; i++) {
                    const section = markdownGuideData[i];
                    htmlB += `<h2>${section.title}</h2>`
                        + `<br>`
                        + `<table class=ews-code-guide>`
                        + `<tr>`
                        + `<th><h4>Type</h4></th>`
                        + `<th colspan=2><h4>Syntax</h4></th>`
                        + `<th><h4>Example</h4></th>`;
                    for (let j = 0; j < section.examples.length; j++) {
                        const example = section.examples[j];
                        htmlB += `<tr>`
                            + `<td><span>${example.type}</span></td>`
                            + `<td>${example.example}</td>`
                            + `<td><span class=ews-icon-paste title="Paste in Editor"data-prefix="${EC_Fmt.Null2EmptyStr(example.prefix)}" data-suffix="${EC_Fmt.Null2EmptyStr(example.suffix)}"/></td>`
                            + `<td style=height:${EC_Fmt.NullChk(example.height, 75)}px><markdown>${example.example}</markdown></td>`
                            + `</tr>`;
                    }
                    htmlB += `</tr>`
                        + `</table>`
                        + `<br>`;
                }

                ECP.Dialog.ShowLoading();

                const markdownGuide = ECP.Dialog.ShowDialog("Markdown Guide", htmlB, {
                    width: 900,
                    height: 1400,
                    confirmButtonTitle: "Close"
                });

                const pasteButtons = markdownGuide.querySelectorAll(".ews-icon-paste");
                const markdownEditor = me.CodeEditors.markdownEditor.editor.monacoEditor;
                const monacoLibrary = me.CodeEditors.markdownEditor.frame.contentWindow.monaco;
                for (let i = 0; i < pasteButtons.length; i++) {
                    pasteButtons[i].addEventListener("click", () => {
                        const selection = markdownEditor.getSelection();
                        const selectedText = markdownEditor.getModel().getValueInRange(markdownEditor.getSelection(selection));
                        markdownEditor.executeEdits("", [
                            {
                                range: new monacoLibrary.Range(selection.startLineNumber, selection.startColumn, selection.endLineNumber, selection.endColumn),
                                text: pasteButtons[i].dataset.prefix + selectedText + pasteButtons[i].dataset.suffix
                            }
                        ]);
                        markdownGuide.parentElement.removeChild(markdownGuide);
                    });
                }

                const markdownGuidePreviews = markdownGuide.querySelectorAll("markdown");
                for (let i = 0; i < markdownGuidePreviews.length; i++) {
                    const markdown = new Markdown(markdownGuidePreviews[i], "", markdownGuidePreviews[i].innerText);
                }

                ECP.Dialog.HideLoading();
            });

            const loadPromises = [];

            // Init Code Editor
            const myEditors = me.EditorContainer.querySelectorAll(".ews-code-editors editor");
            for (let i = 0; i < myEditors.length; i++) {
                const ele = myEditors[i];

                loadPromises.push(() => new Promise((loadResolve) => {
                    me.CodeEditors[ele.id] = new Editor(me.EditorContainer.querySelector(`#${ele.id}`), ele.id, me.Options[`${ele.dataset.type}Content`] || "");

                    ele.addEventListener("ready", () => {
                        loadResolve();

                        me.CodeEditors[ele.id].frame.contentWindow.document.addEventListener("keydown", (event) => {
                            if ((event.ctrlKey || event.metaKey) && event.code === "KeyS") {
                                event.preventDefault();

                                me.SaveCode();

                                return false;
                            }

                            if ((event.altKey || event.metaKey) && (event.code === "ArrowLeft" || event.code === "ArrowRight")) {
                                event.preventDefault();

                                return false;
                            }

                            return true;
                        });
                    });
                }));

                if (ele.dataset.type === "js") {
                    ele.addEventListener("change", () => {
                        if (me.linterDef) {
                            me.linterDef.resolve();
                        }
                    });
                }

                let timer;

                ele.addEventListener("input", function () {
                    const {
                        type
                    } = this.dataset;

                    const span = me.EditorContainer.querySelector(`.ews-code-tabs .ews-code-tab[data-type='${type}'] span`);

                    if (me.CodeEditors[`${type}Editor`].code.replace(/\r\n/g, "\n") !== (me.Options[`${type}Origin`] || "").replace(/\r\n/g, "\n")) {
                        if (!span.innerHTML.includes("*")) {
                            span.innerHTML += "*";
                        }
                    } else if (span.innerHTML.includes("*")) {
                        span.innerHTML = span.innerHTML.replace("*", "");
                    }

                    if (timer) {
                        clearTimeout(timer);
                    }

                    timer = setTimeout(() => {
                        if (type === "markdown") {
                            me.RefreshPreview();
                        }
                    }, 200);
                });
            }

            // Task 954694: Make the UI Kit available in the SDK tab of Code Blocks
            const sdkExternalLink = document.getElementById("ews-code-sdk-externallink");
            if (sdkExternalLink) {
                sdkExternalLink.addEventListener("click", (e) => {
                    let link = me.EditorContainer.querySelector("#sdkPreview").contentWindow.location.href;
                    if (link === "about:blank") {
                        link = "Home?DashboardID=193376";
                    } else {
                        link = link.replace(/EmbededDialog=True/ig, "");
                    }
                    window.open(link);

                    e.stopPropagation();
                });
            }

            document.addEventListener("keydown", (event) => {
                if ((event.ctrlKey || event.metaKey) && event.code === "KeyS") {
                    event.preventDefault();

                    me.SaveCode();

                    return false;
                }

                if ((event.altKey || event.metaKey) && (event.code === "ArrowLeft" || event.code === "ArrowRight")) {
                    event.preventDefault();

                    return false;
                }

                return true;
            });

            // Init Markdown
            const markdown = me.EditorContainer.querySelector("#markdownPreview");

            loadPromises.push(() => new Promise(((loadResolve) => {
                me.Markdown = new Markdown(markdown, markdown.id, me.Options.MarkdownContent || "");

                markdown.addEventListener("ready", () => {
                    loadResolve();
                });
            })));

            loadPromises[0]().then(() => {
                loadPromises.shift();

                Promise.all([].concat(loadPromises.map(promiseFun => promiseFun()))).then(() => {
                    ECP.Dialog.HideLoading();
                    resolve();
                });

                // Change Tab
                const markdownPreview = me.EditorContainer.querySelector("#markdownPreview");
                const testScriptExample = me.EditorContainer.querySelector("#testScriptExample");
                const previewButton = me.EditorContainer.querySelector("#ews-code-preview-button");
                const codeEditorTabs = me.EditorContainer.querySelectorAll(".ews-code-tab");

                const clickTabFunc = (event) => {
                    const tab = event.currentTarget;
                    me.ChangeTab(tab);

                    if (tab.dataset.type === "markdown" && markdownPreview.style.display === "none") {
                        me.RefreshPreview();
                    }

                    if (tab.dataset.type === "test" && testScriptExample.style.display === "none") {
                        me.RefreshPreview();
                    }

                    if ((tab.dataset.type !== "test" && tab.dataset.type !== "markdown" && tab.dataset.type !== "sdk") && (markdownPreview.style.display !== "none" || testScriptExample.style.display !== "none")) {
                        me.RefreshPreview();
                    }

                    if (tab.dataset.type === "markdown" || tab.dataset.type === "test") {
                        if (previewButton.innerText === "Open Preview") {
                            me.TogglePreview(previewButton);
                        }
                    }

                    if (tab.dataset.type === "sdk") {
                        // Init SDK
                        if (!me.SDK) {
                            // Task 954694: Make the UI Kit available in the SDK tab of Code Blocks
                            ECP.Dialog.ShowLoading(null, "#sdkPreview");

                            me.SDK = me.EditorContainer.querySelector("#sdkPreview");
                            me.SDK.addEventListener("load", _ => ECP.Dialog.HideLoading());
                            me.SDK.src = "Home?DashboardID=193376&EmbededDialog=True";
                        }
                        if (previewButton.innerText === "Close Preview") {
                            me.TogglePreview(previewButton);
                        }
                    }
                };

                for (let i = 0; i < codeEditorTabs.length; i++) {
                    codeEditorTabs[i].addEventListener("click", clickTabFunc);
                }
            });
        }

        OpenEditor(options) {
            let optionArgs = options;
            const me = this;

            if (!optionArgs) {
                optionArgs = {};
            }

            me.Options = Object.assign({}, optionArgs);

            if (!me.Options.itemFields) {
                me.Options.itemFields = {};
            }

            // Set Origin Value
            me.Options.htmlOrigin = me.Options.htmlContent || "";
            me.Options.cssOrigin = me.Options.cssContent || "";
            me.Options.jsOrigin = me.Options.jsContent || "";
            me.Options.testOrigin = me.Options.testContent || "";
            me.Options.markdownOrigin = me.Options.markdownContent || "";

            if (me.EditorContainer) {
                const editorKeyArr = Object.keys(me.CodeEditors);

                for (let i = 0; i < editorKeyArr.length; i++) {
                    const key = editorKeyArr[i];
                    const editor = me.CodeEditors[key];
                    const editorId = editor.frame.id.replace("Editor", "");

                    editor.code = me.Options[`${editorId}Content`] || "";
                }

                me.ResetTab();
                me.ChangeTab(me.EditorContainer.querySelectorAll(".ews-code-tab")[0]);
                me.CodeEditors.htmlEditor.focus();
                me.RefreshPreview();
            }

            if (me.Options.testContent) {
                me.Options.testContent = me.Options.testContent.replace("/* eslint-disable */", "").trim();
            }

            me.EditorContainer.style.display = "flex";

            window.removeEventListener("beforeunload", BeforeUnload);
            window.addEventListener("beforeunload", BeforeUnload);

            window.removeEventListener("unload", OnUnload);
            window.addEventListener("unload", OnUnload);

            me.NeedClearCDN = false;
        }

        CloseEditor() {
            this.EditorContainer.style.display = "none";

            window.removeEventListener("beforeunload", BeforeUnload);
            window.removeEventListener("unload", OnUnload);
        }

        ChangeTab(tab) {
            // Task 939222: Refresh the session whenever clicking refresh preview in the code block
            EWS.VerifySession();
            const me = this;

            if (!tab.classList.contains("ews-code-tab-selected")) {
                const {
                    type
                } = tab.dataset;
                const autoFix = me.EditorContainer.querySelector(".ews-code-autofix");

                if (type === "js") {
                    autoFix.style.display = "block";
                } else {
                    autoFix.style.display = "none";
                }

                const viewHistory = me.EditorContainer.querySelector("#ews-code-viewHistory-button");
                if (type === "sdk") {
                    viewHistory.classList.add("disabled");
                } else {
                    viewHistory.classList.remove("disabled");
                }

                const codeEditorTabs = me.EditorContainer.querySelectorAll(".ews-code-tab");
                for (let i = 0; i < codeEditorTabs.length; i++) {
                    codeEditorTabs[i].classList.remove("ews-code-tab-selected");
                    if (codeEditorTabs[i] === tab) {
                        codeEditorTabs[i].classList.add("ews-code-tab-selected");
                    }
                }

                const codeWrappers = me.EditorContainer.querySelectorAll(".ews-code-wrap");
                for (let i = 0; i < codeWrappers.length; i++) {
                    codeWrappers[i].style.display = (codeWrappers[i].dataset.type === type || codeWrappers[i].dataset.type === "sdk") ? "flex" : "none";
                }
            }
        }

        ResetTab() {
            const me = this;

            me.Options.htmlOrigin = me.CodeEditors.htmlEditor.code;
            me.Options.cssOrigin = me.CodeEditors.cssEditor.code;
            me.Options.jsOrigin = me.CodeEditors.jsEditor.code;
            me.Options.testOrigin = me.CodeEditors.testEditor.code;
            me.Options.markdownOrigin = me.CodeEditors.markdownEditor.code;

            const spans = me.EditorContainer.querySelectorAll(".ews-code-tabs .ews-code-tab span");
            for (let i = 0; i < spans.length; i++) {
                if (spans[i].innerHTML.includes("*")) {
                    spans[i].innerHTML = spans[i].innerHTML.replace("*", "");
                }
            }
        }

        TogglePreview(button) {
            const me = this;
            const preview = me.EditorContainer.querySelector(".ews-code-preview");
            const split = me.EditorContainer.querySelector(".ews-code-editor-split");
            const editor = me.EditorContainer.querySelector(".ews-code-editors");
            const autoFix = me.EditorContainer.querySelector(".ews-code-autofix");

            if (getComputedStyle(preview).display === "none") {
                me.RefreshPreview();

                preview.style.display = "block";
                split.style.display = "block";
                preview.style.left = "64%";
                split.style.left = "64%";
                editor.style.right = "36%";
                autoFix.style.right = "36%";
                button.innerText = "Close Preview";
            } else {
                preview.style.display = "none";
                split.style.display = "none";
                editor.style.right = "0%";
                autoFix.style.right = "";
                button.textContent = "Open Preview";
            }
        }

        RefreshPreview() {
            const me = this;
            const previewContainer = me.EditorContainer.querySelector(".ews-code-preview");
            const currentTab = me.EditorContainer.querySelector(".ews-code-tab.ews-code-tab-selected");

            const css = me.CodeEditors.cssEditor.code;
            const html = me.CodeEditors.htmlEditor.code;
            const js = me.CodeEditors.jsEditor.code;
            const md = me.CodeEditors.markdownEditor.code;

            const codePreview = previewContainer.querySelector("#codePreview");

            if (codePreview) {
                codePreview.remove();
            }

            const markdownPreview = previewContainer.querySelector("#markdownPreview");
            const testScriptExample = previewContainer.querySelector("#testScriptExample");

            markdownPreview.style.display = "none";
            testScriptExample.style.display = "none";

            if (currentTab.dataset.type === "markdown") {
                markdownPreview.style.display = "block";
                me.Markdown.code = md;
            } else if (currentTab.dataset.type === "test") {
                testScriptExample.style.display = "block";
            } else {
                const iframe = document.createElement("iframe");

                iframe.id = "codePreview";
                iframe.src = `Home?DashboardID=${Settings.DashboardID}&PreviewCode=True&EmbededDialog=True`;
                iframe.style.height = "100%";
                iframe.style.width = "100%";

                iframe.onload = async function () {
                    const {
                        contentDocument
                    } = iframe;
                    const previewDiv = contentDocument.createElement("div");
                    const contentDiv = EC_Fmt.HtmlStrToElement(`<div class="content"></div>`);

                    previewDiv.classList.add("dashboard-item-preview");
                    previewDiv.classList.add("dashboard-item");

                    previewDiv.appendChild(contentDiv);

                    const mainLayout = contentDocument.getElementById("MainLayout");

                    mainLayout.querySelector(".column").appendChild(previewDiv);

                    const tempDiv = contentDocument.createElement("div");

                    if (css) {
                        const output = await less.render(`div.dashboard-item-preview { ${css} }`);
                        tempDiv.innerHTML = `<style type="text/css">${output.css}</style>`;
                        contentDiv.appendChild(tempDiv.firstChild);
                    }

                    if (html) {
                        tempDiv.innerHTML = html;
                        tempDiv.childNodes.forEach((node) => {
                            contentDiv.appendChild(node);
                        });
                    }

                    if (js) {
                        const newScript = contentDocument.createElement("script");

                        newScript.id = "scriptpreview";
                        newScript.text = `"use strict";function CodeItemJsPreview(dashboardItem) {${js}} //# sourceURL=DashboardItemPreview.js`;

                        contentDiv.append(newScript);

                        if (iframe.contentWindow.CodeItemJsPreview) {
                            // Task 1073687: Error when in custom javascript when editing Yerba Mate Co home dashboard
                            try {
                                iframe.contentWindow.CodeItemJsPreview(previewDiv);
                            } catch (err) {
                                dialog = ECP.Dialog.ShowDialog(EC_Fmt.NullChk(err.name, "Error"), EC_Fmt.NullChk(err.stack, err.toString()), {
                                    width: 550,
                                    cancelButtonTitle: "Cancel"
                                });

                                dialog.querySelector(".ecp-dialog-confirm-button").remove();
                            }
                        }
                    }
                };

                previewContainer.appendChild(iframe);
            }
        }

        async SaveCode(options) {
            const me = this;

            options = options || {};

            const closeEditor = options.closeEditor;
            const deferred = options.deferred;
            const message = options.message;
            const codeData = {
                CodeList: []
            };
            const {
                CodeList
            } = codeData;
            let documentId;

            if (me.Options.htmlOrigin.replace(/\r\n/g, "\n") !== me.CodeEditors.htmlEditor.code.replace(/\r\n/g, "\n")) {
                if (!me.Options.isGlobal) {
                    documentId = me.Options.itemFields && me.Options.itemFields.HtmlDocumentID ? me.Options.itemFields.HtmlDocumentID : "";
                } else {
                    documentId = me.Options.itemFields && me.Options.itemFields.GlobalHtmlDocumentID ? me.Options.itemFields.GlobalHtmlDocumentID : "";
                }

                // Task 951688: Dashboard Edit Html is adding ='' and encoding {{content}}
                CodeList.push({
                    Type: "html",
                    DocumentID: documentId,
                    Content: me.CodeEditors.htmlEditor.code || ""
                });
            }

            if (me.Options.cssOrigin.replace(/\r\n/g, "\n") !== me.CodeEditors.cssEditor.code.replace(/\r\n/g, "\n")) {
                if (!me.Options.isGlobal) {
                    documentId = me.Options.itemFields && me.Options.itemFields.CssDocumentID ? me.Options.itemFields.CssDocumentID : "";
                } else {
                    documentId = me.Options.itemFields && me.Options.itemFields.GlobalCssDocumentID ? me.Options.itemFields.GlobalCssDocumentID : "";
                }

                CodeList.push({
                    Type: "css",
                    DocumentID: documentId,
                    Content: me.CodeEditors.cssEditor.code || ""
                });

                me.NeedClearCDN = true;
            }

            // Task 697919: Code Police - Automatic scanning of the Code Block HTML and Javascript
            me.CodeEditors.jsEditor.fix();

            // Task 962400: All standard company codes should be using eslint, Dashboards should not have eslint-disable
            if (me.CodeEditors.jsEditor.code.match(/\/\*\s*(eslint-disable)[\s\S]*\*\//) || me.CodeEditors.jsEditor.code.match(/\/\/ *(eslint-disable).*/)) {
                ECP.Dialog.Alert("Failed to save the JS file:<br>Please check and change your code, do not use 'eslint-disable' to disable ESLint.");
                return;
            }

            if (me.Options.jsOrigin.replace(/\r\n/g, "\n") !== me.CodeEditors.jsEditor.code.replace(/\r\n/g, "\n")) {
                if (!me.Options.isGlobal) {
                    documentId = me.Options.itemFields && me.Options.itemFields.JsDocumentID ? me.Options.itemFields.JsDocumentID : "";
                } else {
                    documentId = me.Options.itemFields && me.Options.itemFields.GlobalJsDocumentID ? me.Options.itemFields.GlobalJsDocumentID : "";
                }

                CodeList.push({
                    Type: "js",
                    DocumentID: documentId,
                    Content: me.CodeEditors.jsEditor.code || ""
                });

                me.NeedClearCDN = true;
            }

            if (me.Options.testOrigin.replace(/\r\n/g, "\n") !== me.CodeEditors.testEditor.code.replace(/\r\n/g, "\n")) {
                if (!me.Options.isGlobal) {
                    documentId = me.Options.itemFields && me.Options.itemFields.TestDocumentID ? me.Options.itemFields.TestDocumentID : "";
                } else {
                    documentId = me.Options.itemFields && me.Options.itemFields.GlobalTestDocumentID ? me.Options.itemFields.GlobalTestDocumentID : "";
                }
                CodeList.push({
                    Type: "test",
                    DocumentID: documentId,
                    Content: me.CodeEditors.testEditor.code || ""
                });
            }

            if (me.Options.jsOrigin.replace(/\r\n/g, "\n") !== me.CodeEditors.jsEditor.code.replace(/\r\n/g, "\n")) {
                if (!me.Options.isGlobal) {
                    documentId = me.Options.itemFields && me.Options.itemFields.ConvertedJsDocumentID ? me.Options.itemFields.ConvertedJsDocumentID : "";
                } else {
                    documentId = me.Options.itemFields && me.Options.itemFields.GlobalConvertedJsDocumentID ? me.Options.itemFields.GlobalConvertedJsDocumentID : "";
                }

                CodeList.push({
                    Type: "convertedjs",
                    DocumentID: documentId,
                    Content: ""
                });
            }

            if (me.Options.markdownOrigin.replace(/\r\n/g, "\n") !== me.CodeEditors.markdownEditor.code.replace(/\r\n/g, "\n")) {
                if (!me.Options.isGlobal) {
                    documentId = me.Options.itemFields && me.Options.itemFields.MarkdownDocumentID ? me.Options.itemFields.MarkdownDocumentID : "";
                } else {
                    documentId = me.Options.itemFields && me.Options.itemFields.GlobalMarkdownDocumentID ? me.Options.itemFields.GlobalMarkdownDocumentID : "";
                }
                CodeList.push({
                    Type: "markdown",
                    DocumentID: documentId,
                    Content: me.CodeEditors.markdownEditor.code || ""
                });
            }

            if (me.Options.jsOrigin.replace(/\r\n/g, "\n") !== me.CodeEditors.jsEditor.code.replace(/\r\n/g, "\n")) {
                documentId = me.Options.itemFields && me.Options.itemFields.GlobalCompiledJsDocumentID ? me.Options.itemFields.GlobalCompiledJsDocumentID : "";

                CodeList.push({
                    Type: "compiledjs",
                    DocumentID: documentId,
                    Content: ""
                });
            }

            if (me.Options.cssOrigin.replace(/\r\n/g, "\n") !== me.CodeEditors.cssEditor.code.replace(/\r\n/g, "\n")) {
                documentId = me.Options.itemFields && me.Options.itemFields.GlobalCompiledCssDocumentID ? me.Options.itemFields.GlobalCompiledCssDocumentID : "";

                CodeList.push({
                    Type: "compiledcss",
                    DocumentID: documentId,
                    Content: ""
                });
            }

            let createNewDocument = false;

            for (let i = 0; i < CodeList.length; i++) {
                const codeObj = CodeList[i];

                if (EC_Fmt.isNull(codeObj.DocumentID) && !EC_Fmt.isNull(codeObj.Content)) {
                    createNewDocument = true;
                    break;
                }
            }

            ECP.Dialog.ShowLoading("Saving...", ".ews-code-container");

            const myCreateCodeDocumentsRequest = new ECP.EC_Request("Dashboard_CreateCodeDocuments");

            myCreateCodeDocumentsRequest.AddRequestVariable("CodeList", JSON.stringify(codeData), ECP.EC_Verb.Post);
            myCreateCodeDocumentsRequest.AddRequestVariable("Message", message || "", ECP.EC_Verb.Post);

            if (me.SaveDashboardCode) {
                myCreateCodeDocumentsRequest.AddRequestVariable("DashboardID", Settings.DashboardID, ECP.EC_Verb.Post);
                myCreateCodeDocumentsRequest.AddRequestVariable("DashboardVersionID", Settings.DashboardVersionID, ECP.EC_Verb.Post);
            } else if (me.Options.dashboardWidgetID) {
                myCreateCodeDocumentsRequest.AddRequestVariable("DashboardWidgetID", me.Options.dashboardWidgetID, ECP.EC_Verb.Post);
            }

            try {
                const result = await myCreateCodeDocumentsRequest.Submit();
                ECP.Dialog.HideLoading();

                if (result.Status === "success") {
                    const resultKeyArr = Object.keys(result);

                    for (let i = 0; i < resultKeyArr.length; i++) {
                        const key = resultKeyArr[i];
                        const value = result[key];

                        if (key === "CustomErrorMessages") {
                            me.CodeEditors.cssEditor.customErrorMessages = value.CssCustomErrorMessage.ErrorMessageList.length > 0 ? value.CssCustomErrorMessage.ErrorMessageList : [];

                            // Task 942880: CompiledCSS document blank with certain CSS rules
                            for (let k = 0; k < value.CssCustomErrorMessage.ErrorMessageList.length; k++) {
                                const errorObj = value.CssCustomErrorMessage.ErrorMessageList[k];
                                if (errorObj.showAlert) {
                                    ECP.Dialog.Alert(`Failed to save the compiled CSS file:<br><br>(Line ${errorObj.line}, Column ${errorObj.column})<br>Error: ${errorObj.message}`);
                                }
                            }

                            if (result.JsDocument) {
                                me.CodeEditors.jsEditor.code = result.JsDocument;
                            }

                            if (result.CssDocument) {
                                me.CodeEditors.cssEditor.code = result.CssDocument;
                            }

                            if (result.HtmlDocument) {
                                me.CodeEditors.htmlEditor.code = result.HtmlDocument;
                            }
                        } else if (key !== "Status" && key !== "HtmlDocument" && key !== "JsDocument" && key !== "CssDocument") {
                            me.Options.itemFields[(me.Options.isGlobal ? "Global" : "") + key] = value || me.Options.itemFields[(me.Options.isGlobal ? "Global" : "") + key] || "";
                        }
                    }

                    me.ResetTab();

                    if (options.callCallback && me.Options.callback) {
                        if (me.Options.isGlobal) {
                            me.Options.callback(
                                "Code",
                                me.Options.itemFields.GlobalHtmlDocumentID || "",
                                me.Options.itemFields.GlobalCssDocumentID || "",
                                me.Options.itemFields.GlobalJsDocumentID || "",
                                me.Options.itemFields.GlobalTestDocumentID || "",
                                me.Options.itemFields.GlobalConvertedJsDocumentID || "",
                                me.Options.itemFields.GlobalMarkdownDocumentID || "",
                                me.Options.itemFields.GlobalCompiledJsDocumentID || "",
                                me.Options.itemFields.GlobalCompiledCssDocumentID || ""
                            );
                        } else {
                            me.Options.callback(
                                "Code",
                                me.Options.itemFields.HtmlDocumentID || "",
                                me.Options.itemFields.CssDocumentID || "",
                                me.Options.itemFields.JsDocumentID || "",
                                me.Options.itemFields.TestDocumentID || "",
                                me.Options.itemFields.ConvertedJsDocumentID || "",
                                me.Options.itemFields.MarkdownDocumentID || ""
                            );
                        }

                        // Task 1029401: Saving code in a Code Block on a new dashboard, but never saving the dashboard itself can cause the code to be lost
                        if (me.addNewItem || createNewDocument) {
                            Save_Dashboard_Draft(Settings.DashboardID, Settings.DashboardVersionID, (dashboardResult) => {
                                if (dashboardResult?.allDashboardItemIDStr) {
                                    const allDashboardItemIDArr = dashboardResult.allDashboardItemIDStr.split(";");
                                    const dashboardItemArr = document.querySelectorAll(".dashboard-edit .column > div.widget.dashboard-item");

                                    for (let i = 0; i < dashboardItemArr.length; i++) {
                                        const myDashboardItem = dashboardItemArr[i];

                                        if (parseInt(myDashboardItem.id) < 0) {
                                            for (let k = 0; k < allDashboardItemIDArr.length; k++) {
                                                const [oldID, newID] = allDashboardItemIDArr[k].split(",");

                                                if (myDashboardItem.id === oldID) {
                                                    myDashboardItem.id = newID;
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }

                    me.RefreshPreview();

                    if (closeEditor) {
                        me.CloseEditor();
                    } else if (deferred) {
                        deferred.resolve(result);
                    }
                } else {
                    ECP.Dialog.Alert("Save Failed.");

                    if (deferred) {
                        deferred.reject();
                    }
                }
            } catch (err) {
                ECP.Dialog.HideLoading();

                if (deferred) {
                    deferred.reject();
                }
                throw err;
            }
        }

        ValidateTestCode() {
            const me = this;

            if (!me.CodeEditors.testEditor.code || !me.CodeEditors.testEditor.code.replace("/* eslint-disable */\n", "")) {
                ECP.Dialog.Alert("Please add testing code to the 'Test Script' tab first.");
                return false;
            }

            if (!me.CodeEditors.testEditor.code.includes("it(")) {
                ECP.Dialog.Alert("Invalid testing code, please ensure your code follows the <a href='https://mochajs.org/#getting-started'>Mocha testing format</a>.");
                return false;
            }

            if (!me.CodeEditors.testEditor.code.includes("chai.expect") && !me.CodeEditors.testEditor.code.includes("chai.should") && !me.CodeEditors.testEditor.code.includes("chai.assert")) {
                ECP.Dialog.Alert("Invalid testing code, please ensure your code follows the <a href='https://www.chaijs.com/guide/styles/'>Chai testing format</a>.");
                return false;
            }

            return true;
        }

        ViewHistory(editor) {
            const me = this;
            const type = editor.dataset.type.slice(0, 1).toUpperCase() + editor.dataset.type.slice(1);
            let fileType = "";

            switch (type) {
                case "Html":
                    fileType = "html";
                    break;
                case "Js":
                    fileType = "js";
                    break;
                case "Css":
                    fileType = "css";
                    break;
                case "Test":
                    fileType = "js";
                    break;
                case "Markdown":
                    fileType = "md";
                    break;
            }

            let documentId = "";

            if (!me.Options.isGlobal) {
                documentId = me.Options.itemFields && me.Options.itemFields[`${type}DocumentID`] ? me.Options.itemFields[`${type}DocumentID`] : "";
            } else {
                documentId = me.Options.itemFields && me.Options.itemFields[`Global${type}DocumentID`] ? me.Options.itemFields[`Global${type}DocumentID`] : "";
            }

            if (documentId) {
                let htmlB = "<style>.svn-actions {display:flex;margin-bottom:15px} .svn-content,.svn-content > .Table {width:100%} .date-label {line-height:27px;margin-right:5px} .date-label:nth-of-type(2) {margin-left:10px} .search {margin-left:15px} .disabled-event{event-point:none}</style>"
                    + "<div class=svn-actions>"
                    + "</div>"
                    + "<div class=svn-content>"
                    + "</div>";

                const dialog = ECP.Dialog.ShowDialog("Git Commits", htmlB, {
                    confirmButtonTitle: "Ok",
                    width: 600,
                    height: 400
                });

                htmlB = `<span class=date-label>From: </span> ${ECP.HTML.DateInput("From", "From", false, EC_Fmt.DateParseFormat(new Date()), "From", "", 137, false, "From")}`
                    + `<span class=date-label>To: </span> ${ECP.HTML.DateInput("To", "To", false, EC_Fmt.DateParseFormat(new Date()), "To", "", 137, false, "To")}</div>`
                    + `<ecp-btn id=ActionButtonSearch style=margin-left:20px icon=ews-icon-search>Search</ecp-btn>`;

                dialog.querySelector(".svn-actions").innerHTML = htmlB;

                const searchButton = dialog.querySelector("#ActionButtonSearch");

                searchButton.addEventListener("click", () => {
                    me.SearchSVNLogs(documentId, dialog, editor);
                });

                const svnContent = dialog.querySelector(".svn-content");
                const footer = dialog.querySelector(".ecp-dialog-footer");

                footer.prepend(EC_Fmt.HtmlStrToElement("<ecp-btn id=ActionButtonDiff class=disabled>Diff</ecp-btn>"));
                footer.prepend(EC_Fmt.HtmlStrToElement("<ecp-btn id=ActionButtonDiffWithWorkingCopy class=disabled>Diff with working copy</ecp-btn>"));

                const diffButton = footer.querySelector("#ActionButtonDiff");

                diffButton.addEventListener("click", () => {
                    const selectedTrs = svnContent.querySelectorAll("tr.Dim");
                    const revisions = Array.from(selectedTrs).map(selectedTr => selectedTr.querySelectorAll("td")[1].innerHTML.trim());

                    TabCodeEditor.ShowDiffDialog(editor.getAttribute("language"), documentId, revisions);
                });

                const diffWithButton = footer.querySelector("#ActionButtonDiffWithWorkingCopy");

                diffWithButton.addEventListener("click", () => {
                    const selectedTr = svnContent.querySelector("tr.Dim");
                    const revisions = [selectedTr.querySelectorAll("td")[1].innerHTML.trim()];
                    const content = me.CodeEditors[`${fileType}Editor`].code;

                    TabCodeEditor.ShowDiffDialog(editor.getAttribute("language"), documentId, revisions, true, content);
                });

                svnContent.addEventListener("click", (event) => {
                    const tr = event.target.closest("tbody tr");
                    if (event.target.classList.contains("ews-icon-rotateleft")) {
                        ECP.Dialog.CloseDialog(dialog);
                    } else if (tr) {
                        const checkbox = tr.querySelector("input[type='checkbox']");

                        tr.classList.toggle("Dim");
                        checkbox.checked = tr.classList.contains("Dim");

                        const selectedTrs = svnContent.querySelectorAll("tr.Dim");

                        if (selectedTrs.length < 2) {
                            diffButton.classList.add("disabled");
                        } else {
                            diffButton.classList.remove("disabled");

                            if (selectedTrs.length > 2) {
                                let firstTr = selectedTrs[0];

                                if (tr === firstTr) {
                                    firstTr = selectedTrs[1];
                                }

                                firstTr.classList.remove("Dim");
                                firstTr.querySelector("input[type='checkbox']").checked = false;
                            }
                        }

                        if (selectedTrs.length === 1) {
                            diffWithButton.classList.remove("disabled");
                        } else {
                            diffWithButton.classList.add("disabled");
                        }
                    }
                });
            } else {
                ECP.Dialog.Alert("No Git Logs.");
            }
        }

        SearchSVNLogs(documentId, dialog, editor) {
            const me = this;
            let startTime = dialog.querySelector("#From").value;
            let endTime = dialog.querySelector("#To").value;

            if (startTime) {
                startTime = EC_Fmt.ToDate(startTime);
                // Task 628299: Dashboard SVN: lost commit log when save dashboard code
                startTime = `${startTime.getFullYear()}-${startTime.getMonth() + 1}-${startTime.getDate()}`;
            }

            if (endTime) {
                endTime = EC_Fmt.ToDate(endTime);
                endTime.setDate(endTime.getDate() + 1);
                // Task 628299: Dashboard SVN: lost commit log when save dashboard code
                endTime = `${endTime.getFullYear()}-${endTime.getMonth() + 1}-${endTime.getDate()}`;
            }

            ECP.Dialog.ShowLoading("Searching", dialog.firstChild);

            const myRequest = new ECP.EC_Request("Get_CodeSVNLogs");

            myRequest.AddRequestVariable("GlobalDocumentID", documentId);
            myRequest.AddRequestVariable("StartTime", startTime);
            myRequest.AddRequestVariable("EndTime", endTime);
            myRequest.AddRequestVariable("DashboardID", Settings.DashboardID);
            myRequest.AddRequestVariable("DashboardVersionID", Settings.DashboardVersionID);

            myRequest.Submit().then((logs) => {
                let htmlB = "<table class=Table>"
                    + "<thead>"
                    + "<tr>"
                    + "<th class=Parent></th>"
                    + "<th class=Parent>Commit</th>"
                    + "<th class=Parent>Author</th>"
                    + "<th class=Parent>Date</th>"
                    + "<th class=Parent>Message</th>"
                    + "<th class=Parent>Revert</th>"
                    + "</tr>"
                    + "<tbody>";

                if (logs.LOG) {
                    for (let index = 0; index < logs.LOG.length; index++) {
                        const log = logs.LOG[index];
                        let author;
                        let message = "";
                        const describeArr = log.Describe.split("{^}");

                        if (describeArr.length > 1) {
                            message = describeArr[0];
                            author = describeArr[1];
                        } else {
                            author = describeArr[0];
                        }

                        author = author.replace("Committed By ", "");

                        htmlB += "<tr>"
                            + `<td><input type=checkbox></td>`
                            + `<td>${log.LogNUM}</td>`
                            + `<td>${author}</td>`
                            + `<td>${EC_Fmt.DateTimeParseFormat(log.Time)}</td>`
                            + `<td>${message}</td>`
                            + `<td class='link-icon-column'><span class=ews-icon-rotateleft data-lognum='${log.LogNUM}'></span></td>`
                            + "</tr>";
                    }
                }

                htmlB += "</tbody>"
                    + "</thead>"
                    + "</table>";
                const svnContent = dialog.querySelector(".svn-content");
                svnContent.innerHTML = htmlB;
                const revertButtons = svnContent.querySelectorAll(".ews-icon-rotateleft");
                for (let i = 0; i < revertButtons.length; i++) {
                    revertButtons[i].addEventListener("click", async () => {
                        ECP.Dialog.ShowLoading();

                        const revision = revertButtons[i].dataset.lognum;
                        // Task 727188: Using the Revert button inside of 'History' in a code block is causing a system error
                        const myGetCodeRequest = new ECP.EC_Request("Get_CodeSVNContent");

                        myGetCodeRequest.SetReturnType(ECP.EC_ReturnType.Text);
                        myGetCodeRequest.AddRequestVariable("GlobalDocumentID", documentId);
                        myGetCodeRequest.AddRequestVariable("CommitID", revision);
                        myGetCodeRequest.AddRequestVariable("DashboardID", Settings.DashboardID);
                        myGetCodeRequest.AddRequestVariable("DashboardVersionID", Settings.DashboardVersionID);

                        const oldText = await myGetCodeRequest.Submit();
                        const activeEditor = editor.parentElement.querySelector("iframe").contentWindow;
                        activeEditor.editor.monacoEditor.executeEdits("", [
                            { range: new activeEditor.monaco.Range(0, 0, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER), text: oldText }
                        ]);

                        if (oldText !== editor.code) {
                            const {
                                type
                            } = editor.dataset;

                            const span = me.EditorContainer.querySelector(`.ews-code-tabs .ews-code-tab[data-type='${type}'] span`);

                            if (!span.innerHTML.includes("*")) {
                                span.innerHTML += "*";
                            }
                        }

                        ECP.Dialog.HideLoading();
                    });
                }
                ECP.Dialog.HideLoading();
            });
        }

        static ShowDiffDialog(language, documentId, revisions, diffWithWorkingCopy, codeContent) {
            const htmlB = "<style>.svn-diff-container {height:100%;width:100%;display:flex;flex-direction:column} .svn-diff-actions {height:40px} .svn-diff-editors {flex:1;display:flex;flex-direction:column} .svn-diff-revisions {height:20px;display:flex} .svn-diff-revision {flex:1;text-align:center;font-size:15px} .svn-diff-editor {flex:1;border:1px solid rgb(136, 136, 136)}</style>"
                + "<div class=svn-diff-container>"
                + "<div class=svn-diff-actions>"
                + "<ecp-btn id=ActionButtonPrev icon=ews-icon-previous>Prev</ecp-btn>"
                + "<ecp-btn id=ActionButtonNext icon=ews-icon-next>Next</ecp-btn>"
                + "</div>"
                + "<div class=svn-diff-editors>"
                + "<div class=svn-diff-revisions>"
                + `<div class=svn-diff-revision><span>Revision ${diffWithWorkingCopy ? revisions[0] : revisions[1]}</span></div>`
                + `<div class=svn-diff-revision><span>${diffWithWorkingCopy ? "Working Copy" : `Revision ${revisions[0]}`}</span></div>`
                + "</div>"
                + "<div class=svn-diff-editor>"
                + `<editor previewFix=true language="${language}"></editor>`
                + "</div>"
                + "</div>"
                + "</div>";

            let title;
            if (diffWithWorkingCopy) {
                title = `${revisions[0]} - Working Copy}`;
            } else {
                title = `${revisions[1]} - ${revisions[0]}`;
            }

            const dialog = ECP.Dialog.ShowDialog(`Git Commit Diff: ${title}`, htmlB, {
                height: window.innerHeight,
                width: window.innerWidth
            });

            ECP.Dialog.ShowLoading("", dialog.firstChild);

            const editorElement = dialog.querySelector("editor");
            const diffEditor = new Editor(editorElement, "diffEditor", "");

            editorElement.addEventListener("ready", () => {
                const promises = [];

                for (let i = 0; i < revisions.length; i++) {
                    const revision = revisions[i];
                    // Task 727188: Using the Revert button inside of 'History' in a code block is causing a system error
                    const myRequest = new ECP.EC_Request("Get_CodeSVNContent");

                    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
                    myRequest.AddRequestVariable("GlobalDocumentID", documentId);
                    myRequest.AddRequestVariable("CommitID", revision);
                    myRequest.AddRequestVariable("DashboardID", Settings.DashboardID);
                    myRequest.AddRequestVariable("DashboardVersionID", Settings.DashboardVersionID);

                    const promise = myRequest.Submit();

                    promises.push(promise);
                }

                Promise.all(promises).then((contents) => {
                    if (diffWithWorkingCopy) {
                        diffEditor.fixedCode = codeContent;
                        diffEditor.code = contents[0];
                    } else {
                        diffEditor.fixedCode = contents[0];
                        diffEditor.code = contents[1];
                    }

                    ECP.Dialog.HideLoading();

                    const diffNav = diffEditor.frame.contentWindow.monaco.editor.createDiffNavigator(diffEditor.editor.monacoEditor, {
                        followsCaret: true,
                        ignoreCharChanges: true
                    });

                    const prevButton = dialog.querySelector("#ActionButtonPrev");
                    const nextButton = dialog.querySelector("#ActionButtonNext");

                    function checkButtonStatus() {
                        if (diffNav.nextIdx === 0) {
                            prevButton.classList.add("disabled");
                        } else {
                            prevButton.classList.remove("disabled");
                        }

                        if (diffNav.nextIdx === diffNav.ranges.length - 1) {
                            nextButton.classList.add("disabled");
                        } else {
                            nextButton.classList.remove("disabled");
                        }
                    }

                    setTimeout(() => {
                        if (!diffNav.canNavigate()) {
                            prevButton.classList.add("disabled");
                            nextButton.classList.add("disabled");
                        } else {
                            checkButtonStatus();
                        }

                        prevButton.addEventListener("click", () => {
                            if (!prevButton.classList.contains("disabled")) {
                                diffNav.previous();

                                checkButtonStatus();
                            }
                        });

                        nextButton.addEventListener("click", () => {
                            if (!nextButton.classList.contains("disabled")) {
                                diffNav.next();

                                checkButtonStatus();
                            }
                        });
                    }, 500);
                });
            });
        }

        static RunTest(argsTmp) {
            args = argsTmp;
            return new Promise(runTestFunction);
        }
    }

    const tabCodeEditor = new TabCodeEditor();

    EWS.DashboardItemTypesManager.add("Code", {
        showEditButton: true,
        itemFields: ["GlobalHtmlDocumentID", "GlobalJsDocumentID", "GlobalCssDocumentID", "GlobalTestDocumentID", "GlobalConvertedJsDocumentID", "GlobalMarkdownDocumentID", "GlobalCompiledJsDocumentID", "GlobalCompiledCssDocumentID"],
        addItem(createNewItemCallback) {
            tabCodeEditor.InitEditors(null, true).then(() => {
                tabCodeEditor.OpenEditor({
                    callback(title, htmlDocumentId, cssDocumentId, jsDocumentId, testDocumentId, convertedJsDocumentId, markdownDocumentId, compiledJsDocumentId, compiledCssDocumentID) {
                        const dashboardItem = createNewItemCallback(title, {}, {
                            html: htmlDocumentId,
                            css: cssDocumentId,
                            javascript: jsDocumentId,
                            testScript: testDocumentId,
                            convertedJs: convertedJsDocumentId,
                            markdown: markdownDocumentId,
                            compiledJavascript: compiledJsDocumentId,
                            compiledCss: compiledCssDocumentID
                        });

                        return dashboardItem;
                    },
                    isGlobal: true
                });
            }, () => { });

            tabCodeEditor.SaveDashboardCode = true;
        },
        editItem(title, itemFields, dashboardItem, editItemCallback) {
            itemFields = itemFields || {};

            let hasItemFields = false;
            const itemFieldsKeys = Object.keys(itemFields);

            for (let index = 0; index < itemFieldsKeys.length; index++) {
                const key = itemFieldsKeys[index];

                if (itemFields[key]) {
                    hasItemFields = true;
                    break;
                }
            }

            // Task 913841: Can not run Test Scripts when the dashboard has no CSS file and has Js file
            if (!hasItemFields) {
                itemFields.GlobalHtmlDocumentID = dashboardItem.getAttribute("data-document-html") || "";
                itemFields.GlobalJsDocumentID = dashboardItem.getAttribute("data-document-javascript") || "";
                itemFields.GlobalCssDocumentID = dashboardItem.getAttribute("data-document-css") || "";
                itemFields.GlobalTestDocumentID = dashboardItem.getAttribute("data-document-testScript") || "";
                itemFields.GlobalConvertedJsDocumentID = dashboardItem.getAttribute("data-document-convertedJs") || "";
                itemFields.GlobalMarkdownDocumentID = dashboardItem.getAttribute("data-document-markdown") || "";
            }

            itemFields.GlobalCompiledJsDocumentID = dashboardItem.getAttribute("data-document-compiledJavascript") || "";
            itemFields.GlobalCompiledCssDocumentID = dashboardItem.getAttribute("data-document-compiledCss") || "";

            tabCodeEditor.InitEditors(dashboardItem).then(() => {
                tabCodeEditor.OpenEditor({
                    callback(_title, htmlDocumentId, cssDocumentId, jsDocumentId, testDocumentId, convertedJsDocumentId, markdownDocumentId, compiledJsDocumentId, compiledCssDocumentId) {
                        dashboardItem = editItemCallback(_title, hasItemFields ? {
                            GlobalHtmlDocumentID: htmlDocumentId,
                            GlobalJsDocumentID: jsDocumentId,
                            GlobalCssDocumentID: cssDocumentId,
                            GlobalTestDocumentID: testDocumentId,
                            GlobalConvertedJsDocumentID: convertedJsDocumentId,
                            GlobalMarkdownDocumentID: markdownDocumentId,
                            GlobalCompiledJsDocumentID: compiledJsDocumentId,
                            GlobalCompiledCssDocumentID: compiledCssDocumentId
                        } : {}, {
                            html: htmlDocumentId,
                            css: cssDocumentId,
                            javascript: jsDocumentId,
                            testscript: testDocumentId,
                            convertedjs: convertedJsDocumentId,
                            markdown: markdownDocumentId,
                            compiledJavascript: compiledJsDocumentId,
                            compiledCss: compiledCssDocumentId
                        });

                        return dashboardItem;
                    },
                    isGlobal: true,
                    htmlContent: dashboardItem.querySelector(".code_html_init") ? dashboardItem.querySelector(".code_html_init").value : "",
                    cssContent: dashboardItem.querySelector(".code_css_init") ? dashboardItem.querySelector(".code_css_init").value : "",
                    jsContent: dashboardItem.querySelector(".code_js_init") ? dashboardItem.querySelector(".code_js_init").value : "",
                    testContent: dashboardItem.querySelector(".code_test_init") ? dashboardItem.querySelector(".code_test_init").value : "",
                    markdownContent: dashboardItem.querySelector(".code_markdown_init") ? dashboardItem.querySelector(".code_markdown_init").value : "",
                    itemFields
                });
            }, () => { });

            tabCodeEditor.SaveDashboardCode = true;
        },
        getDashboardDocuments(dashboardItem) {
            return GetDashboardDocuments(dashboardItem);
        },
        createEditButtons(dashboardItem) {
            const diamond = dashboardItem.querySelector(".widget-tools .ews-icon-diamond");

            if (diamond) {
                diamond.parentElement.removeChild(diamond);
            }

            let editButtons = dashboardItem.querySelector(".code-action");

            if (editButtons) {
                editButtons = editButtons.cloneNode();

                editButtons.classList.remove("hidden");
            }

            return editButtons;
        }
    });

    EWS.Ready((EWS) => {
        // Convert click
        const dashboardContainer = document.querySelector(".dashboard-edit");

        if (dashboardContainer) {
            dashboardContainer.addEventListener("click", async (event) => {
                if (event.target.matches(".item-action")) {
                    const trigger = event.target;
                    const DashboardItem = trigger.parentElement.parentElement;
                    const type = DashboardItem.getAttribute("item-type");

                    if ((type === "Code" || type === "PrivateCode") && trigger.getAttribute("action") === "Publish") {
                        const jsContent = DashboardItem.querySelector(".code_js_init") ? DashboardItem.querySelector(".code_js_init").value : "";
                        const testContent = DashboardItem.querySelector(".code_test_init") ? DashboardItem.querySelector(".code_test_init").value : "";

                        // Check ESLint Error
                        if (jsContent) {
                            await tabCodeEditor.InitEditors();

                            ECP.Dialog.ShowLoading("Check Javascript code errors......");

                            tabCodeEditor.linterDef = null;
                            tabCodeEditor.CodeEditors.jsEditor.code = "";

                            const linterChange = new Deferred();

                            tabCodeEditor.linterDef = linterChange;

                            requestAnimationFrame(() => {
                                tabCodeEditor.CodeEditors.jsEditor.code = jsContent;
                                tabCodeEditor.CodeEditors.testEditor.code = testContent;
                            });

                            await linterChange;

                            ECP.Dialog.HideLoading();

                            const {
                                errors
                            } = tabCodeEditor.CodeEditors.jsEditor;

                            if (errors.length > 0) {
                                ECP.Dialog.ShowDialog("Javascript Code Error", `<div style="font-size:16px;margin:auto;min-height:117px;display:flex;flex-direction:column;align-items:center;justify-content:center">The javascript code has ${errors.length} error${errors.length > 1 ? "s" : ""}. Please change your code.</div>`, {
                                    confirmButtonTitle: "OK"
                                });

                                return;
                            }
                        }

                        // Run Test
                        if (jsContent && testContent) {
                            // Run test script
                            if (!tabCodeEditor.ValidateTestCode()) {
                                return;
                            }

                            TabCodeEditor.RunTest(Object.assign({}, {
                                GlobalHtmlDocumentID: DashboardItem.getAttribute("data-document-html") || "",
                                GlobalCssDocumentID: DashboardItem.getAttribute("data-document-css") || "",
                                GlobalJsDocumentID: DashboardItem.getAttribute("data-document-javascript") || "",
                                GlobalConvertedJsDocumentID: DashboardItem.getAttribute("data-document-convertedjs") || "",
                                GlobalTestDocumentID: DashboardItem.getAttribute("data-document-testscript") || "",
                                GlobalCompiledJsDocumentID: DashboardItem.getAttribute("data-document-compiledJavascript") || "",
                                GlobalCompiledCssDocumentID: DashboardItem.getAttribute("data-document-compiledCss") || ""
                            }, {
                                isGlobal: type === "Code",
                                confirmButtonTitle: "Next",
                                confirmButtonAction() {
                                    OpenPublishDialog({
                                        dashboardDocuments: GetDashboardDocuments(DashboardItem)
                                    });
                                }
                            })).catch(() => {
                                ECP.Dialog.ShowDialog("Test Result", "<div style=margin:auto>Test cases must pass and<br>must have at least 80% code coverage.<br>Please fix your code and/or test cases.</div>", {
                                    confirmButtonTitle: "OK"
                                });
                            });
                        } else {
                            OpenPublishDialog({
                                dashboardDocuments: GetDashboardDocuments(DashboardItem)
                            });
                        }
                    }
                }
            });
        }

        // Edit Published Code Item Type
        const DashboardItemEditButtons = document.querySelectorAll("#dashboard-item-library .ews-dashboard-library-edit");

        for (let i = 0, len = DashboardItemEditButtons.length; i < len; i++) {
            DashboardItemEditButtons[i].addEventListener("click", async (event) => {
                const itemTypeElement = event.currentTarget.closest(".ews-dashboard-library-item");
                const dashboardWidgetID = itemTypeElement.getAttribute("item-id");

                ECP.Dialog.ShowLoading();

                const myGetWidgetGlobalDocumentRequest = new ECP.EC_Request("DashboardWidget_GetWidgetGlobalDocument");

                myGetWidgetGlobalDocumentRequest.AddRequestVariable("DashboardWidgetID", dashboardWidgetID);

                const result = await myGetWidgetGlobalDocumentRequest.Submit();

                ECP.Dialog.HideLoading();

                if (result.ErrorMessage) {
                    ECP.Dialog.Alert(result.ErrorMessage);
                } else {
                    const dashboardWidgetVersionID = result.DashboardWidgetVersionID;

                    tabCodeEditor.InitEditors().then(() => {
                        const globalDocuments = result.GlobalDocuments;

                        globalDocuments[DashboardDocumentType.HTML] = globalDocuments[DashboardDocumentType.HTML] || {
                            Type: DashboardDocumentType.HTML
                        };
                        globalDocuments[DashboardDocumentType.Javascript] = globalDocuments[DashboardDocumentType.Javascript] || {
                            Type: DashboardDocumentType.Javascript
                        };
                        globalDocuments[DashboardDocumentType.CSS] = globalDocuments[DashboardDocumentType.CSS] || {
                            Type: DashboardDocumentType.CSS
                        };
                        globalDocuments[DashboardDocumentType.TestScript] = globalDocuments[DashboardDocumentType.TestScript] || {
                            Type: DashboardDocumentType.TestScript
                        };
                        globalDocuments[DashboardDocumentType.ConvertedJs] = globalDocuments[DashboardDocumentType.ConvertedJs] || {
                            Type: DashboardDocumentType.ConvertedJs
                        };
                        globalDocuments[DashboardDocumentType.Markdown] = globalDocuments[DashboardDocumentType.Markdown] || {
                            Type: DashboardDocumentType.Markdown
                        };
                        globalDocuments[DashboardDocumentType.CompiledJavascript] = globalDocuments[DashboardDocumentType.CompiledJavascript] || {
                            Type: DashboardDocumentType.CompiledJavascript
                        };
                        globalDocuments[DashboardDocumentType.CompiledCss] = globalDocuments[DashboardDocumentType.CompiledCss] || {
                            Type: DashboardDocumentType.CompiledCss
                        };

                        tabCodeEditor.OpenEditor({
                            async callback(title, htmlDocumentId, cssDocumentId, jsDocumentId, testDocumentId, convertedJsDocumentID, markdownDocumentId, compiledJsDocumentId, compiledCssDocumentId) {
                                tabCodeEditor.Options.globalDocuments[DashboardDocumentType.HTML].GlobalDocumentID = htmlDocumentId;
                                tabCodeEditor.Options.globalDocuments[DashboardDocumentType.Javascript].GlobalDocumentID = jsDocumentId;
                                tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CSS].GlobalDocumentID = cssDocumentId;
                                tabCodeEditor.Options.globalDocuments[DashboardDocumentType.TestScript].GlobalDocumentID = testDocumentId;
                                tabCodeEditor.Options.globalDocuments[DashboardDocumentType.ConvertedJs].GlobalDocumentID = convertedJsDocumentID;
                                tabCodeEditor.Options.globalDocuments[DashboardDocumentType.Markdown].GlobalDocumentID = markdownDocumentId;
                                tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CompiledJavascript].GlobalDocumentID = compiledJsDocumentId;
                                tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CompiledCss].GlobalDocumentID = compiledCssDocumentId;

                                // save to dashboard item type fields
                                const documents = {
                                    GlobalDocuments: []
                                };

                                documents.GlobalDocuments.push(Object.assign({}, tabCodeEditor.Options.globalDocuments[DashboardDocumentType.HTML], {
                                    Content: ""
                                }));

                                documents.GlobalDocuments.push(Object.assign({}, tabCodeEditor.Options.globalDocuments[DashboardDocumentType.Javascript], {
                                    Content: ""
                                }));

                                documents.GlobalDocuments.push(Object.assign({}, tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CSS], {
                                    Content: ""
                                }));

                                documents.GlobalDocuments.push(Object.assign({}, tabCodeEditor.Options.globalDocuments[DashboardDocumentType.TestScript], {
                                    Content: ""
                                }));

                                documents.GlobalDocuments.push(Object.assign({}, tabCodeEditor.Options.globalDocuments[DashboardDocumentType.ConvertedJs], {
                                    Content: ""
                                }));

                                documents.GlobalDocuments.push(Object.assign({}, tabCodeEditor.Options.globalDocuments[DashboardDocumentType.Markdown], {
                                    Content: ""
                                }));

                                documents.GlobalDocuments.push(Object.assign({}, tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CompiledJavascript], {
                                    Content: ""
                                }));

                                documents.GlobalDocuments.push(Object.assign({}, tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CompiledCss], {
                                    Content: ""
                                }));

                                const mySaveWidgetDocumentsRequest = new ECP.EC_Request("Dashboard_SaveWidgetDocuments");

                                mySaveWidgetDocumentsRequest.AddRequestVariable("DashboardWidgetID", dashboardWidgetID, ECP.EC_Verb.Post);
                                mySaveWidgetDocumentsRequest.AddRequestVariable("DashboardWidgetVersionID", dashboardWidgetVersionID, ECP.EC_Verb.Post);
                                mySaveWidgetDocumentsRequest.AddRequestVariable("GlobalDocuments", JSON.stringify({ root: documents.GlobalDocuments }), ECP.EC_Verb.Post);

                                ECP.Dialog.ShowLoading("Saving......");

                                const saveFieldsResult = await mySaveWidgetDocumentsRequest.Submit();

                                ECP.Dialog.HideLoading();

                                if (result.ErrorMessage) {
                                    ECP.Dialog.Alert(saveFieldsResult.ErrorMessage);
                                } else {
                                    Object.assign(tabCodeEditor.Options.globalDocuments, saveFieldsResult.GlobalDocuments);
                                }

                                tabCodeEditor.Options.itemFields = {
                                    GlobalHtmlDocumentID: tabCodeEditor.Options.globalDocuments[DashboardDocumentType.HTML].GlobalDocumentID || "",
                                    GlobalJsDocumentID: tabCodeEditor.Options.globalDocuments[DashboardDocumentType.Javascript].GlobalDocumentID || "",
                                    GlobalCssDocumentID: tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CSS].GlobalDocumentID || "",
                                    GlobalTestDocumentID: tabCodeEditor.Options.globalDocuments[DashboardDocumentType.TestScript].GlobalDocumentID || "",
                                    GlobalConvertedJsDocumentID: tabCodeEditor.Options.globalDocuments[DashboardDocumentType.ConvertedJs].GlobalDocumentID || "",
                                    GlobalMarkdownDocumentID: tabCodeEditor.Options.globalDocuments[DashboardDocumentType.Markdown].GlobalDocumentID || "",
                                    GlobalCompiledJsDocumentID: tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CompiledJavascript].GlobalDocumentID || "",
                                    GlobalCompiledCssDocumentID: tabCodeEditor.Options.globalDocuments[DashboardDocumentType.CompiledCss].GlobalDocumentID || ""
                                };
                            },
                            isGlobal: true,
                            globalDocuments,
                            htmlContent: globalDocuments[DashboardDocumentType.HTML].Content || "",
                            cssContent: globalDocuments[DashboardDocumentType.CSS].Content || "",
                            jsContent: globalDocuments[DashboardDocumentType.Javascript].Content || "",
                            testContent: globalDocuments[DashboardDocumentType.TestScript].Content || "",
                            markdownContent: globalDocuments[DashboardDocumentType.Markdown].Content || "",
                            itemFields: {
                                GlobalHtmlDocumentID: globalDocuments[DashboardDocumentType.HTML].GlobalDocumentID || "",
                                GlobalJsDocumentID: globalDocuments[DashboardDocumentType.Javascript].GlobalDocumentID || "",
                                GlobalCssDocumentID: globalDocuments[DashboardDocumentType.CSS].GlobalDocumentID || "",
                                GlobalTestDocumentID: globalDocuments[DashboardDocumentType.TestScript].GlobalDocumentID || "",
                                GlobalConvertedJsDocumentID: globalDocuments[DashboardDocumentType.ConvertedJs].GlobalDocumentID || "",
                                GlobalMarkdownDocumentID: globalDocuments[DashboardDocumentType.Markdown].GlobalDocumentID || "",
                                GlobalCompiledJsDocumentID: globalDocuments[DashboardDocumentType.CompiledJavascript].GlobalDocumentID || "",
                                GlobalCompiledCssDocumentID: globalDocuments[DashboardDocumentType.CompiledCss].GlobalDocumentID || ""
                            }
                        });
                    }, () => { });
                }
            });
        }

        EWS.TabCodeEditor = TabCodeEditor;
    });

    function OpenPublishDialog(publishArgs) {
        EWS.VerifySession(() => {
            const myPublishDialogRequest = new ECP.EC_Request("DashboardWidget_PublishDialog");

            myPublishDialogRequest.Submit().then((result) => {
                const dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                    width: 485,
                    height: 408,
                    cancelButtonTitle: result.cancel,
                    confirmButtonTitle: result.publish,
                    confirmButtonAction() {
                        const widget = dialog.querySelector("#ews-dashboard-item-widget").value.trim();
                        const widgetCategory = dialog.querySelector("#DashboardWidgetCategoryHidden").value;
                        const permission = dialog.querySelector("#PermissionHidden").value;
                        const description = dialog.querySelector("#ews-dashboard-item-description").value.trim();
                        const iconID = dialog.querySelector("#IconHidden").value;
                        const minVersion = dialog.querySelector("#ews-dashboard-item-minversion").value.trim();
                        const maxVersion = dialog.querySelector("#ews-dashboard-item-maxversion").value.trim();
                        const applicationID = dialog.querySelector("#ApplicationHidden").value;

                        if (!widget) {
                            dialog.style.display = "block";
                            ECP.Dialog.Alert("Please enter the Widget Name.");
                            return;
                        }

                        if (!widgetCategory) {
                            dialog.style.display = "block";
                            ECP.Dialog.Alert("Please select the Widget Category.");
                            return;
                        }

                        if (!iconID) {
                            dialog.style.display = "block";
                            ECP.Dialog.Alert("Please select the Icon.");
                            return;
                        }

                        if (!permission) {
                            dialog.style.display = "block";
                            ECP.Dialog.Alert("Please select the Permission.");
                            return;
                        }

                        if (!applicationID) {
                            dialog.style.display = "block";
                            ECP.Dialog.Alert("Please select the Application.");
                            return;
                        }

                        const mySaveWidgetRequest = new ECP.EC_Request("Dashboard_SaveDashboardWidget");

                        mySaveWidgetRequest.AddRequestVariable("DashboardWidget", widget, ECP.EC_Verb.Post);
                        mySaveWidgetRequest.AddRequestVariable("DashboardWidgetCategory", widgetCategory, ECP.EC_Verb.Post);
                        mySaveWidgetRequest.AddRequestVariable("Permission", permission, ECP.EC_Verb.Post);
                        mySaveWidgetRequest.AddRequestVariable("Description", description, ECP.EC_Verb.Post);
                        mySaveWidgetRequest.AddRequestVariable("IconID", iconID, ECP.EC_Verb.Post);
                        mySaveWidgetRequest.AddRequestVariable("MinECPVersion", minVersion, ECP.EC_Verb.Post);
                        mySaveWidgetRequest.AddRequestVariable("MaxECPVersion", maxVersion, ECP.EC_Verb.Post);
                        mySaveWidgetRequest.AddRequestVariable("ApplicationID", applicationID, ECP.EC_Verb.Post);
                        mySaveWidgetRequest.AddRequestVariable("DashboardDocuments", JSON.stringify({ root: publishArgs.dashboardDocuments }), ECP.EC_Verb.Post);

                        ECP.Dialog.ShowLoading();

                        mySaveWidgetRequest.Submit().then((submitResult) => {
                            ECP.Dialog.HideLoading();

                            if (!submitResult.status) {
                                dialog.style.display = "block";
                            }
                        }).catch((error) => {
                            ECP.Dialog.HideLoading();
                            dialog.style.display = "block";
                            throw error;
                        });
                    }
                });

                const inputs = dialog.querySelectorAll(".AutoCompleteInput");

                for (let i = 0; i < inputs.length; i++) {
                    const ajaxInput = new ECP.HTML.AjaxInput(inputs[i]);
                }
            });
        });
    }

    function OnUnload() {
        const codeItems = document.querySelectorAll("div[item-type='Code']");
        for (let i = 0, len = codeItems.length; i < len; i++) {
            // Task 939024: Need to Release 'Edit Lock' when close the window.
            if (window.navigator && window.navigator.sendBeacon) {
                window.navigator.sendBeacon(`api?APICommand=Dashboard_MarkCodeBlockClosed&DashboardItemID=${codeItems[i].id}`);
            } else {
                fetch(`api?APICommand=Dashboard_MarkCodeBlockClosed&DashboardItemID=${codeItems[i].id}`, { credentials: "same-origin" });
            }
        }
    }

    function BeforeUnload(event) {
        const spans = tabCodeEditor.EditorContainer.querySelectorAll(".ews-code-tabs .ews-code-tab span");
        let changed = false;

        for (let index = 0; index < spans.length; index++) {
            const span = spans[index];

            if (span.innerHTML.includes("*")) {
                changed = true;
                break;
            }
        }

        if (changed) {
            event.preventDefault();
            event.returnValue = "";
        }
    }

    function GetDashboardDocuments(dashboardItem) {
        const dashboardDocuments = [];

        if (dashboardItem.getAttribute("data-document-html")) {
            dashboardDocuments.push({
                Type: DashboardDocumentType.HTML,
                GlobalDocumentID: dashboardItem.getAttribute("data-document-html")
            });
        }

        if (dashboardItem.getAttribute("data-document-javascript")) {
            dashboardDocuments.push({
                Type: DashboardDocumentType.Javascript,
                GlobalDocumentID: dashboardItem.getAttribute("data-document-javascript")
            });
        }

        if (dashboardItem.getAttribute("data-document-css")) {
            dashboardDocuments.push({
                Type: DashboardDocumentType.CSS,
                GlobalDocumentID: dashboardItem.getAttribute("data-document-css")
            });
        }

        if (dashboardItem.getAttribute("data-document-testscript")) {
            dashboardDocuments.push({
                Type: DashboardDocumentType.TestScript,
                GlobalDocumentID: dashboardItem.getAttribute("data-document-testscript")
            });
        }

        if (dashboardItem.getAttribute("data-document-convertedjs")) {
            dashboardDocuments.push({
                Type: DashboardDocumentType.ConvertedJs,
                GlobalDocumentID: dashboardItem.getAttribute("data-document-convertedjs")
            });
        }

        if (dashboardItem.getAttribute("data-document-markdown")) {
            dashboardDocuments.push({
                Type: DashboardDocumentType.Markdown,
                GlobalDocumentID: dashboardItem.getAttribute("data-document-markdown")
            });
        }

        if (dashboardItem.getAttribute("data-document-compiledJavascript")) {
            dashboardDocuments.push({
                Type: DashboardDocumentType.CompiledJavascript,
                GlobalDocumentID: dashboardItem.getAttribute("data-document-compiledJavascript")
            });
        }

        if (dashboardItem.getAttribute("data-document-compiledCss")) {
            dashboardDocuments.push({
                Type: DashboardDocumentType.CompiledCss,
                GlobalDocumentID: dashboardItem.getAttribute("data-document-compiledCss")
            });
        }

        return dashboardDocuments;
    }
}());
